var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg11To1SessionDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408.001,
    height: 366.922,
    viewBox: "0 0 408.001 366.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25370",
    "data-name": "Rectangle 25370",
    width: 408.001,
    height: 366.921,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25369",
    "data-name": "Rectangle 25369",
    width: 407.999,
    height: 366.919,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25307",
    "data-name": "Rectangle 25307",
    width: 50.133,
    height: 43.634,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25308",
    "data-name": "Rectangle 25308",
    width: 38.904,
    height: 24.197,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25339",
    "data-name": "Rectangle 25339",
    width: 63.44,
    height: 59.89,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25340",
    "data-name": "Rectangle 25340",
    width: 54.359,
    height: 59.889,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25341",
    "data-name": "Rectangle 25341",
    width: 41.716,
    height: 73.78,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25342",
    "data-name": "Rectangle 25342",
    width: 12.567,
    height: 65.059,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25343",
    "data-name": "Rectangle 25343",
    width: 44.969,
    height: 68.672,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25344",
    "data-name": "Rectangle 25344",
    width: 11.431,
    height: 2.634,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25347",
    "data-name": "Rectangle 25347",
    width: 65.451,
    height: 146.445,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25351",
    "data-name": "Rectangle 25351",
    width: 185.035,
    height: 20.344,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25352",
    "data-name": "Rectangle 25352",
    width: 184.617,
    height: 0.497,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25355",
    "data-name": "Rectangle 25355",
    width: 8.806,
    height: 146.445,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25358",
    "data-name": "Rectangle 25358",
    width: 8.805,
    height: 146.445,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25361",
    "data-name": "Rectangle 25361",
    width: 42.505,
    height: 45.569,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25362",
    "data-name": "Rectangle 25362",
    width: 36.502,
    height: 38.552,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25363",
    "data-name": "Rectangle 25363",
    width: 30.218,
    height: 29.057,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88090",
    "data-name": "Group 88090",
    transform: "translate(-15448 -21316.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88089",
    "data-name": "Group 88089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88087",
    "data-name": "Group 88087",
    transform: "translate(1600.612 1387.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87502",
    "data-name": "Group 87502",
    transform: "translate(13847.388 19928.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87501",
    "data-name": "Group 87501",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87500",
    "data-name": "Group 87500",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87499",
    "data-name": "Group 87499",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275647",
    "data-name": "Path 275647",
    d: "M133.776,29.589A29.589,29.589,0,1,1,104.187,0a29.59,29.59,0,0,1,29.589,29.589",
    transform: "translate(233.851 -0.002)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275648",
    "data-name": "Path 275648",
    d: "M131.719,28.72A28.233,28.233,0,1,1,103.487.487,28.233,28.233,0,0,1,131.719,28.72",
    transform: "translate(235.907 1.525)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275649",
    "data-name": "Path 275649",
    d: "M128.586,27.368A26.45,26.45,0,1,1,102.135.918a26.45,26.45,0,0,1,26.45,26.45",
    transform: "translate(237.259 2.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87453",
    "data-name": "Group 87453",
    transform: "translate(315.111 6.831)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87452",
    "data-name": "Group 87452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87451",
    "data-name": "Group 87451",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275650",
    "data-name": "Path 275650",
    d: "M126.344,19.453C114.3,26.751,94.5,38.722,83.437,45.288a26.524,26.524,0,0,1-7.228-9.721l36.6-33.914a26.478,26.478,0,0,1,13.537,17.8",
    transform: "translate(-76.21 -1.651)",
    fill: "#ececec"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87456",
    "data-name": "Group 87456",
    transform: "translate(326.921 31.169)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87455",
    "data-name": "Group 87455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87454",
    "data-name": "Group 87454",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275651",
    "data-name": "Path 275651",
    d: "M117.969,7.539a26.161,26.161,0,0,1-1.749,8.6l-32.988,15.6a26.423,26.423,0,0,1-4.168-1.79c9.965-5.76,28.175-16.237,38.9-22.407",
    transform: "translate(-79.067 -7.537)",
    fill: "#ececec"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25309",
    "data-name": "Rectangle 25309",
    width: 0.513,
    height: 4.011,
    transform: "translate(339.138 5.714)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275652",
    "data-name": "Path 275652",
    d: "M81.067,5.876,79.062,2.4l.442-.256L81.51,5.619Z",
    transform: "translate(247.844 6.726)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275653",
    "data-name": "Path 275653",
    d: "M80.386,6.743,76.913,4.738l.256-.442L80.642,6.3Z",
    transform: "translate(241.107 13.464)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25310",
    "data-name": "Rectangle 25310",
    width: 4.011,
    height: 0.513,
    transform: "translate(314.862 29.99)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275654",
    "data-name": "Path 275654",
    d: "M77.169,12.191l-.256-.442,3.473-2.005.256.442Z",
    transform: "translate(241.108 30.542)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275655",
    "data-name": "Path 275655",
    d: "M79.5,15.312l-.442-.256,2.005-3.473.442.256Z",
    transform: "translate(247.845 36.306)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25311",
    "data-name": "Rectangle 25311",
    width: 0.513,
    height: 4.011,
    transform: "translate(339.138 50.767)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275656",
    "data-name": "Path 275656",
    d: "M86.515,15.312,84.51,11.839l.442-.256,2.005,3.473Z",
    transform: "translate(264.922 36.306)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275657",
    "data-name": "Path 275657",
    d: "M89.822,12.191l-3.473-2.005.256-.442,3.473,2.005Z",
    transform: "translate(270.688 30.542)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25312",
    "data-name": "Rectangle 25312",
    width: 4.011,
    height: 0.513,
    transform: "translate(359.915 29.99)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275658",
    "data-name": "Path 275658",
    d: "M86.605,6.743,86.349,6.3,89.822,4.3l.256.442Z",
    transform: "translate(270.688 13.464)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275659",
    "data-name": "Path 275659",
    d: "M84.952,5.876l-.442-.256,2.005-3.473.442.256Z",
    transform: "translate(264.923 6.726)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275660",
    "data-name": "Path 275660",
    d: "M83.416,1.828l.868,24.5L81.779,26.3,82.734,1.82Z",
    transform: "translate(256.361 5.703)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275661",
    "data-name": "Path 275661",
    d: "M99.27,5.7,82.785,16.223l-1.195-2.2L98.943,5.1Z",
    transform: "translate(255.768 15.998)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275662",
    "data-name": "Path 275662",
    d: "M83.587,7.964a.856.856,0,1,1-.856-.856.858.858,0,0,1,.856.856",
    transform: "translate(256.663 22.281)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25313",
    "data-name": "Rectangle 25313",
    width: 104.139,
    height: 6.182,
    transform: "translate(29.039 45.971)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25314",
    "data-name": "Rectangle 25314",
    width: 6.186,
    height: 20.451,
    transform: "translate(119.087 52.152)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25315",
    "data-name": "Rectangle 25315",
    width: 6.186,
    height: 6.322,
    transform: "translate(119.087 52.152)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25316",
    "data-name": "Rectangle 25316",
    width: 6.186,
    height: 20.451,
    transform: "translate(36.94 52.152)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25317",
    "data-name": "Rectangle 25317",
    width: 6.186,
    height: 6.322,
    transform: "translate(36.94 52.152)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25318",
    "data-name": "Rectangle 25318",
    width: 9.924,
    height: 39.409,
    transform: "translate(96.937 6.562)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25319",
    "data-name": "Rectangle 25319",
    width: 9.924,
    height: 4.329,
    transform: "translate(96.937 4.453)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25320",
    "data-name": "Rectangle 25320",
    width: 9.924,
    height: 1.608,
    transform: "translate(96.937 14.331)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25321",
    "data-name": "Rectangle 25321",
    width: 11.16,
    height: 4.329,
    transform: "translate(95.7 36.469)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25322",
    "data-name": "Rectangle 25322",
    width: 6.934,
    height: 45.971,
    transform: "translate(89.998)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25323",
    "data-name": "Rectangle 25323",
    width: 4.164,
    height: 17.68,
    transform: "translate(91.413 4.321)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25324",
    "data-name": "Rectangle 25324",
    width: 45.971,
    height: 6.935,
    transform: "matrix(0.711, -0.703, 0.703, 0.711, 40.654, 41.045)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25325",
    "data-name": "Rectangle 25325",
    width: 17.682,
    height: 4.162,
    transform: "matrix(0.711, -0.703, 0.703, 0.711, 49.285, 34.431)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25326",
    "data-name": "Rectangle 25326",
    width: 11.78,
    height: 34.919,
    transform: "translate(78.222 11.056)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25327",
    "data-name": "Rectangle 25327",
    width: 11.78,
    height: 3.254,
    transform: "translate(78.222 39.02)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25328",
    "data-name": "Rectangle 25328",
    width: 11.78,
    height: 1.261,
    transform: "translate(78.222 35.621)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25329",
    "data-name": "Rectangle 25329",
    width: 8.137,
    height: 32.818,
    transform: "translate(106.856 13.161)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25330",
    "data-name": "Rectangle 25330",
    width: 8.137,
    height: 3.06,
    transform: "translate(106.856 39.438)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25331",
    "data-name": "Rectangle 25331",
    width: 8.137,
    height: 3.06,
    transform: "translate(106.856 19.926)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25332",
    "data-name": "Rectangle 25332",
    width: 8.137,
    height: 1.187,
    transform: "translate(106.856 25.078)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275663",
    "data-name": "Path 275663",
    d: "M43.465,0H92.248V48.783H43.465Zm2.3,46.479H89.944V2.3H45.764Z",
    transform: "translate(136.255 -0.002)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25333",
    "data-name": "Rectangle 25333",
    width: 34.435,
    height: 15.274,
    transform: "translate(188.585 22.651)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25334",
    "data-name": "Rectangle 25334",
    width: 11.536,
    height: 33.327,
    transform: "translate(189.61 72.103)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25335",
    "data-name": "Rectangle 25335",
    width: 24.247,
    height: 14.488,
    transform: "translate(186.918 133.798)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275664",
    "data-name": "Path 275664",
    d: "M43.465,15.172H92.248V63.955H43.465Zm2.3,46.484H89.944V17.475H45.764Z",
    transform: "translate(136.255 47.56)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275665",
    "data-name": "Path 275665",
    d: "M43.465,30.345H92.248V79.128H43.465Zm2.3,46.484H89.944V32.648H45.764Z",
    transform: "translate(136.255 95.124)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25336",
    "data-name": "Rectangle 25336",
    width: 17.643,
    height: 17.643,
    transform: "translate(195.287 15.568)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25337",
    "data-name": "Rectangle 25337",
    width: 17.643,
    height: 17.643,
    transform: "translate(195.287 78.305)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25338",
    "data-name": "Rectangle 25338",
    width: 17.643,
    height: 17.643,
    transform: "translate(195.287 141.043)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275666",
    "data-name": "Path 275666",
    d: "M28.463,69.837c-8.154.207-16.618.31-25.032.376l0-.376-.091-10.42c.012-.542-.141-.476.467-.467l24.66.219.252,0-.008.244Zm0,0-.248-10.42.248.244L3.8,59.88l.463-.463-.1,10.42L3.8,69.465c8.137.066,16.254.17,24.66.372h0",
    transform: "translate(10.429 184.775)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275667",
    "data-name": "Path 275667",
    d: "M25.135,73.015c-8.15.207-16.618.31-25.032.376l0-.376L.008,62.6c.017-.542-.145-.476.467-.467l24.66.219.252,0,0,.244Zm0,0L24.887,62.6l.248.244-24.66.219L.938,62.6l-.1,10.42-.368-.372c8.137.066,16.254.169,24.66.372h0",
    transform: "translate(0.001 194.737)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275668",
    "data-name": "Path 275668",
    d: "M88.375,32.35c-8.15.207-16.618.31-25.028.376l0-.376-.1-10.42c.017-.542-.145-.476.467-.467l24.66.219.252,0,0,.244Zm0,0-.248-10.42.248.244-24.66.219.463-.463-.1,10.42-.368-.372c8.137.066,16.254.17,24.66.372h0",
    transform: "translate(198.246 67.26)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275669",
    "data-name": "Path 275669",
    d: "M85.048,35.528c-8.15.207-16.618.31-25.028.376l0-.376-.1-10.42c.017-.542-.145-.476.467-.467l24.66.219.252,0,0,.244Zm0,0L84.8,25.108l.248.244-24.66.219.463-.463-.1,10.42-.368-.372c8.141.066,16.254.17,24.66.372h0",
    transform: "translate(187.817 77.222)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275670",
    "data-name": "Path 275670",
    d: "M81.734,32.35c-8.15.207-16.618.31-25.028.376l0-.376-.1-10.42c.017-.542-.145-.476.467-.467l24.66.219.252,0,0,.244Zm0,0-.248-10.42.248.244-24.66.219.463-.463-.1,10.42-.368-.372c8.137.066,16.254.17,24.66.372h0",
    transform: "translate(177.428 67.26)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275671",
    "data-name": "Path 275671",
    d: "M117.669,73.015c-8.15.207-16.618.31-25.032.376v-.376l-.1-10.42c.017-.542-.145-.476.467-.467l24.66.219.252,0,0,.244Zm0,0-.248-10.42.248.244-24.66.219.463-.463-.1,10.42-.368-.372c8.137.066,16.254.169,24.66.372h0",
    transform: "translate(290.078 194.737)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275672",
    "data-name": "Path 275672",
    d: "M114.342,11.373c-8.15.207-16.618.31-25.028.376l0-.376-.1-10.42c.017-.542-.145-.476.467-.467l24.66.219.252,0,0,.244Zm0,0L114.094.953l.248.244-24.66.219.463-.463-.1,10.42L89.682,11c8.137.066,16.254.165,24.66.372h0",
    transform: "translate(279.648 1.501)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275673",
    "data-name": "Path 275673",
    d: "M117.669,14.551c-8.15.207-16.618.31-25.032.376v-.376l-.1-10.42c.017-.542-.145-.476.467-.467l24.66.219.252,0,0,.244Zm0,0-.248-10.42.248.244-24.66.219.463-.463-.1,10.42-.368-.372c8.137.066,16.254.17,24.66.372h0",
    transform: "translate(290.078 11.463)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275674",
    "data-name": "Path 275674",
    d: "M28.462,11.374c-8.154.207-16.618.31-25.032.376l0-.376L3.335.954C3.351.408,3.19.478,3.8.487l24.66.219.252,0-.008.244Zm0,0L28.214.954l.248.244L3.8,1.417,4.265.954l-.1,10.42L3.8,11c8.137.066,16.254.165,24.66.372h0",
    transform: "translate(10.43 1.501)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275675",
    "data-name": "Path 275675",
    d: "M396.127,97.653c0,9.535-88.307,17.263-197.239,17.263S1.649,107.188,1.649,97.653,89.96,80.39,198.888,80.39s197.239,7.728,197.239,17.263",
    transform: "translate(5.169 252.006)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275676",
    "data-name": "Path 275676",
    d: "M1.043,76.168c99.6-.442,300.018-.442,399.593,0-99.6.442-300.022.442-399.593,0",
    transform: "translate(3.27 237.729)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275677",
    "data-name": "Path 275677",
    d: "M24.636,59.022l2.1,12.619,14.253,76.978h2.3L32.927,71.641,31.4,59.022Z",
    transform: "translate(77.23 185.021)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275678",
    "data-name": "Path 275678",
    d: "M31.4,59.022h-6.76l2.1,12.619h6.186Z",
    transform: "translate(77.229 185.021)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275679",
    "data-name": "Path 275679",
    d: "M13.81,148.619h2.3L30.362,71.641l2.1-12.619h-6.76l-1.53,12.619Z",
    transform: "translate(43.293 185.021)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275680",
    "data-name": "Path 275680",
    d: "M17.848,59.022l-1.53,12.619H22.5l2.1-12.619Z",
    transform: "translate(51.153 185.021)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275681",
    "data-name": "Path 275681",
    d: "M3.47,148.619h2.3L20.022,71.641l2.1-12.619h-6.76l-1.53,12.619Z",
    transform: "translate(10.878 185.021)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275682",
    "data-name": "Path 275682",
    d: "M5.977,71.641h6.186l2.1-12.619H7.507Z",
    transform: "translate(18.736 185.02)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275683",
    "data-name": "Path 275683",
    d: "M4.351,126.767H108.8V115.76H69.7L56.562,39.3H8.333Z",
    transform: "translate(13.641 123.206)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275684",
    "data-name": "Path 275684",
    d: "M4.351,126.767h5.694L13.758,39.3H8.333Z",
    transform: "translate(13.641 123.206)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275685",
    "data-name": "Path 275685",
    d: "M76.523,134.653c-2.076.26-58.764-12.967-60.608-14.749-.223-.2,2.456-11.085,2.456-11.085.893-4.478,15.654-41.038,15.654-41.038l37.06,9.142-15.7,33.889s7.066,4.78,13.136,9.341l.017.021a82.266,82.266,0,0,1,7.678,6.14c1.8,2.158,2.386,8.1.31,8.34",
    transform: "translate(49.849 212.479)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275686",
    "data-name": "Path 275686",
    d: "M76.519,112.934c-2.076.261-58.764-12.963-60.6-14.749-.223-.2,2.46-11.085,2.46-11.085.3-1.468,2.084-6.413,4.362-12.392l35.473,8.27-2.832,6.111s7.066,4.788,13.14,9.349l.008.016a80.438,80.438,0,0,1,7.682,6.144c1.807,2.158,2.386,8.092.31,8.336",
    transform: "translate(49.849 234.194)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275687",
    "data-name": "Path 275687",
    d: "M77.022,109.517c-2.146.223-59.293-12.582-61.158-14.451-.719-.7,4.35-19.107,4.375-19.215L56.815,83.93l-.153.62s18.379,14.091,20.211,16.361,2.295,8.39.149,8.6",
    transform: "translate(49.512 237.777)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275688",
    "data-name": "Path 275688",
    d: "M74.663,93.123c-9.58-2.394-48.448-11.156-58.1-12.793-.079-.017-.091.037-.012.058C26,82.973,64.93,91.416,74.63,93.281c.2.041.236-.107.033-.157",
    transform: "translate(51.722 251.809)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275689",
    "data-name": "Path 275689",
    d: "M35.457,78.926c-3.63-1.555-8.4-2.014-11.9.033-.136.079-.021.273.108.261a54.774,54.774,0,0,1,11.668.182.248.248,0,0,0,.124-.475",
    transform: "translate(73.653 243.22)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275690",
    "data-name": "Path 275690",
    d: "M36.029,79.473c-3.63-1.555-8.4-2.014-11.9.033-.136.079-.021.273.108.26a54.5,54.5,0,0,1,11.668.182.248.248,0,0,0,.124-.476",
    transform: "translate(75.446 244.935)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275691",
    "data-name": "Path 275691",
    d: "M36.6,80.019c-3.63-1.555-8.4-2.014-11.9.033-.136.079-.021.273.108.26a54.509,54.509,0,0,1,11.668.182.248.248,0,0,0,.124-.476",
    transform: "translate(77.239 246.646)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275692",
    "data-name": "Path 275692",
    d: "M38.413,77.569c-1.03-2.382-4.011-2.08-5.892-1.108a20.683,20.683,0,0,0-7.786,7.364.1.1,0,0,0,.058.153.482.482,0,0,0,.488.608c3.391-.455,7.071-.525,10.221-2.005,1.84-.864,3.883-2.758,2.911-5.011M30.28,82.845c-1.662.265-3.329.447-4.978.773a61.234,61.234,0,0,1,4.643-4.2A21.862,21.862,0,0,1,32.438,77.7c1.36-.773,6.314-1.952,4.714,2.051-.885,2.208-4.891,2.779-6.872,3.093",
    transform: "translate(77.482 237.424)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275693",
    "data-name": "Path 275693",
    d: "M24.3,82.073c2.828,2.03,6.434,2.766,9.684,3.833.335.112.591-.211.591-.509a.1.1,0,0,0,.087-.141A20.694,20.694,0,0,0,28.351,76.6c-1.67-1.3-4.548-2.138-5.991.017-1.373,2.038.294,4.271,1.943,5.458m-1.1-3.085c-.844-4.23,3.812-2.167,5.007-1.158a22.284,22.284,0,0,1,2.142,2.142,62.246,62.246,0,0,1,3.8,4.978c-1.563-.624-3.167-1.1-4.755-1.67-1.89-.67-5.727-1.96-6.19-4.292",
    transform: "translate(68.499 236.029)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275694",
    "data-name": "Path 275694",
    d: "M77.589,179.695l-39.537-8.853S70.659,95.191,67.773,91.367C66.33,89.452,29.7,88.89,18.052,79.02,2.923,66.2,13.074,46.611,13.074,46.611L53.98,45.4s-.5,8.543,1.1,9.833c1.054.856,49.8,4.954,55.146,21.377,6.566,20.141-32.636,103.085-32.636,103.085",
    transform: "translate(30.536 142.319)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275695",
    "data-name": "Path 275695",
    d: "M53.258,83.059C52.211,82.621,42,79.727,39.716,79.14c-4.6-1.174-9.212-2.336-13.839-3.42-2.411-.566-7.583-1.8-7.893-1.774a.128.128,0,0,0-.021.252c4.511,1.406,9.068,2.634,13.624,3.878s20.219,5.069,21.58,5.218c.132.017.24-.174.091-.236",
    transform: "translate(56.001 231.805)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275696",
    "data-name": "Path 275696",
    d: "M71,84.983a6.2,6.2,0,0,0-3.089-.959Q59.059,82.542,50.2,81.055c-5.524-.926-11.077-1.753-16.576-2.812-4.557-.881-9.188-2.063-13.128-4.532a19.049,19.049,0,0,1-8.042-10.519,34.016,34.016,0,0,1-1.042-13.48c.108-1.1.31-2.2.513-3.279.017-.083-.116-.112-.128-.029-1.5,8.377-1.633,18.1,4.652,24.776,3.06,3.254,7.269,5.169,11.561,6.4a130.347,130.347,0,0,0,14.877,2.89q8.857,1.482,17.718,2.956c2.841.471,5.727.843,8.543,1.431a2.887,2.887,0,0,1,1.538.682,2.2,2.2,0,0,1,.252,2.047c-.285,1.389-.662,2.762-1.059,4.127-3.225,11-24.978,63.474-25.615,64.681-.07.128.132.227.2.1,5.417-9.647,21.179-50.176,24.755-60.579a65.957,65.957,0,0,0,2.324-8.1c.2-.992.322-2.109-.542-2.845",
    transform: "translate(34.301 145.316)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275697",
    "data-name": "Path 275697",
    d: "M104.323,127.766c-1.985.666-58.723-.132-60.881-1.513-.839-.8-1.505-8.055-2.018-17.081l-9.762-38.7,36.5-.3,10.688,38.433s7.877,3.279,14.736,6.541l.017.017a80.733,80.733,0,0,1,8.753,4.495c2.191,1.757,3.949,7.459,1.964,8.108",
    transform: "translate(99.255 219.975)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275698",
    "data-name": "Path 275698",
    d: "M98.347,100c-2.051.678-60.616.4-62.837-1.03-.856-.525-1.311-9.051-1.567-19.367,0-.107,0-.215,0-.323l37.788-.24-.021.641S94.08,89.8,96.358,91.627c2.258,1.819,4.04,7.7,1.989,8.373",
    transform: "translate(106.393 247.777)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275699",
    "data-name": "Path 275699",
    d: "M94.511,83.806c-9.87-.289-49.713-.525-59.5-.062-.079,0-.079.058,0,.062,9.779.5,49.622.414,59.5.161.207,0,.207-.153,0-.161",
    transform: "translate(109.58 261.701)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275700",
    "data-name": "Path 275700",
    d: "M52.935,79.3c-3.883-.744-8.638-.17-11.619,2.58-.116.107.037.269.165.232a54.614,54.614,0,0,1,11.437-2.324.247.247,0,0,0,.017-.488",
    transform: "translate(129.39 247.648)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275701",
    "data-name": "Path 275701",
    d: "M53.611,79.71c-3.883-.744-8.638-.17-11.619,2.58-.116.107.037.269.165.232A54.617,54.617,0,0,1,53.594,80.2a.247.247,0,0,0,.017-.488",
    transform: "translate(131.509 248.94)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275702",
    "data-name": "Path 275702",
    d: "M54.288,80.121c-3.883-.744-8.638-.17-11.619,2.58-.116.108.037.269.165.232a54.616,54.616,0,0,1,11.437-2.324.247.247,0,0,0,.017-.488",
    transform: "translate(133.631 250.228)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275703",
    "data-name": "Path 275703",
    d: "M54.442,77.973c-1.513-2.109-4.362-1.174-5.991.178a20.677,20.677,0,0,0-6.024,8.857.1.1,0,0,0,.091.141.483.483,0,0,0,.608.488c3.213-1.17,6.793-2.026,9.551-4.147,1.608-1.236,3.2-3.523,1.766-5.516m-6.81,6.893c-1.567.612-3.155,1.149-4.7,1.819a60.942,60.942,0,0,1,3.634-5.094,21.81,21.81,0,0,1,2.067-2.212c1.162-1.046,5.747-3.258,5.044.992-.389,2.349-4.18,3.763-6.049,4.495",
    transform: "translate(132.973 240.538)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275704",
    "data-name": "Path 275704",
    d: "M42.525,84.15c3.2,1.377,6.876,1.327,10.279,1.675a.486.486,0,0,0,.471-.624.1.1,0,0,0,.05-.157A20.693,20.693,0,0,0,45.3,77.935c-1.91-.91-4.9-1.112-5.851,1.3-.9,2.282,1.207,4.106,3.072,4.912m-1.741-2.774c-1.732-3.949,3.258-2.932,4.643-2.2a22.29,22.29,0,0,1,2.551,1.637,61.884,61.884,0,0,1,4.776,4.048c-1.662-.273-3.333-.4-5-.612-1.989-.252-6.012-.691-6.967-2.87",
    transform: "translate(123.004 242.334)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275705",
    "data-name": "Path 275705",
    d: "M155.475,185.259l-42.593-.033S94.652,112.9,91.427,108.781c-4.3-5.491-64.491-5.367-77.4-23.283C2.433,69.41,12.221,46.639,12.221,46.639L57.8,45.287a93.79,93.79,0,0,1-4.226,14.335s54.91,10.118,70.292,26.938c10.378,11.35,31.611,98.7,31.611,98.7",
    transform: "translate(26.208 141.965)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275706",
    "data-name": "Path 275706",
    d: "M32.56,48A21.985,21.985,0,0,0,28.7,49.237c-1.311.5-2.6,1.067-3.858,1.679a76.785,76.785,0,0,0-7.211,4.073c-.07.046,0,.145.074.108,2.464-1.278,5.011-2.427,7.563-3.527q1.842-.794,3.684-1.584a39.267,39.267,0,0,0,3.721-1.646c.157-.087.07-.372-.112-.339",
    transform: "translate(55.173 150.464)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275707",
    "data-name": "Path 275707",
    d: "M25.359,45.394c-.521,2.076-.98,4.172-1.575,6.231-.273.943-.542,1.906-.9,2.82-.3.773-.761,1.658-1.658,1.832-1.034.2-1.327-.686-1.245-1.538.1-.951.339-1.9.525-2.836.219-1.079.438-2.158.633-3.242.1-.542.2-1.083.294-1.625.025-.136.124-1.174.2-1.472.008.025.025.05.058.045l.037,0a.076.076,0,0,0,.062-.054c.008-.083.008-.1-.054-.157a.087.087,0,0,0-.1-.008c-.194.112-.211.38-.273.579-.17.525-.339,1.05-.492,1.584-.289.988-.571,1.985-.823,2.985s-.5,2-.744,3.006a4.67,4.67,0,0,0-.2,2.307,1.766,1.766,0,0,0,1.637,1.327c-.037.07-.079.132-.112.2-.091.207-.157.426-.236.633s-.149.43-.211.649a2.214,2.214,0,0,0-.062.323c-.012.12.012.24,0,.36a.174.174,0,0,0,.323.116c.054-.108.136-.19.194-.289a1.548,1.548,0,0,0,.149-.351c.07-.207.132-.413.186-.628s.116-.418.157-.633c.021-.124.025-.252.037-.38a2.41,2.41,0,0,0,1.2-.459,4.012,4.012,0,0,0,1.245-1.9c.314-.864.554-1.761.8-2.646a38.908,38.908,0,0,0,1.327-6.694.193.193,0,0,0-.376-.083",
    transform: "translate(59.644 141.837)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275708",
    "data-name": "Path 275708",
    d: "M70.564,77.659a33.552,33.552,0,0,0-3.415-.211c-1.195-.05-2.394-.1-3.593-.141-2.361-.066-4.718-.112-7.079-.12-4.755-.017-9.506-.017-14.261.062-2.477.037-7.79.107-8.084.2a.122.122,0,0,0,.037.24c4.718.252,9.44.331,14.162.418s9.44.157,14.153.079c1.307-.025,2.613-.074,3.92-.107a40.483,40.483,0,0,0,4.131-.178c.132-.021.186-.219.029-.244",
    transform: "translate(106.712 241.94)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275709",
    "data-name": "Path 275709",
    d: "M92.514,106.8a12.564,12.564,0,0,0-1.778-3.668,6.515,6.515,0,0,0-3.49-1.795c-11.354-3.109-23.072-4.5-34.617-6.686A141.135,141.135,0,0,1,35.78,90.551a65.351,65.351,0,0,1-15.94-7.17,17.809,17.809,0,0,1-5.863-6.19,26.759,26.759,0,0,1-2.754-7.736,47.227,47.227,0,0,1,.041-18.7A44.252,44.252,0,0,1,12.43,46.2c.029-.1-.116-.128-.145-.037A45.472,45.472,0,0,0,9.718,64.75c.413,5.475,1.741,11.238,5.28,15.588a21.943,21.943,0,0,0,6.554,5.144,69.625,69.625,0,0,0,8.026,3.779A106.628,106.628,0,0,0,46.125,94.2c11.515,2.547,23.271,3.841,34.786,6.4q2.127.478,4.246,1.009a14.971,14.971,0,0,1,4.184,1.348c1.364.852,1.815,2.551,2.353,3.965.6,1.563,19.107,64.218,19.525,65.793.07.256.455.136.393-.116-1.617-6.4-17.9-62.721-19.1-65.8",
    transform: "translate(30.084 144.545)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275710",
    "data-name": "Path 275710",
    d: "M46.827,66.69c-.434-1.369-.81-2.836-2.084-3.668-1.183-.769-19.5-3.271-21.551-3.585-.1-.017-.132.128-.037.145,1.757.3,18.59,3.312,20.1,3.812a3.343,3.343,0,0,1,1.642,1.063,7.128,7.128,0,0,1,.959,2.282q.782,2.45,1.555,4.891c1.038,3.271,2.076,6.545,3.064,9.837,1.116,3.725,2.4,7.633,3.362,11.4.074.285.484.149.434-.132-1.282-7.075-6.9-24.346-7.439-26.049",
    transform: "translate(72.413 186.321)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275711",
    "data-name": "Path 275711",
    d: "M19.563,48.782a153.284,153.284,0,0,1,24.867,5.1,173.9,173.9,0,0,1,23.99,8.675C72.782,64.511,77,66.7,81.188,69c.083.045.008.165-.074.124A194.929,194.929,0,0,0,57.781,58.95,187.868,187.868,0,0,0,33.48,51.9c-4.643-1.009-9.32-1.794-14-2.572-.31-.054-.227-.583.087-.55",
    transform: "translate(60.442 152.917)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275712",
    "data-name": "Path 275712",
    d: "M21.743,47.661c4.321,9.609,21.2,40.534,31.545,42.353,6.793,1.191,33.9-2.522,38.326-9.146,1.931-2.886-2.3-22.307-5.9-21.385s-25.3,4.672-28.005,4S34,40.487,26.274,35.045c-13.331-9.382-6.86,7.443-4.532,12.615",
    transform: "translate(56.786 101.1)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275713",
    "data-name": "Path 275713",
    d: "M79.234,59.678,80.979,89.04s-21.406,4.792-30.767,1.6C38.841,86.757,22.095,51.657,19.8,45.889c-3.771-9.477-2.758-15.224,2.539-13.839,2.059.521,4.772,2.129,8.1,5.036C33.912,40.116,53.9,59.773,60.206,63.478c3.523,2.072,19.028-3.8,19.028-3.8",
    transform: "translate(54.982 99.825)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87459",
    "data-name": "Group 87459",
    transform: "translate(72.521 131.668)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87458",
    "data-name": "Group 87458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87457",
    "data-name": "Group 87457",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275714",
    "data-name": "Path 275714",
    d: "M79.234,59.678,80.979,89.04s-21.406,4.792-30.767,1.6C38.841,86.757,22.095,51.657,19.8,45.889c-3.771-9.477-2.758-15.224,2.539-13.839,2.059.521,4.772,2.129,8.1,5.036C33.912,40.116,53.9,59.773,60.206,63.478c3.523,2.072,19.028-3.8,19.028-3.8",
    transform: "translate(-17.539 -31.843)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275715",
    "data-name": "Path 275715",
    d: "M32.516,65.293c-.389-4.333-1.327-22.113-1.274-25.971,0-.265.178-.327.207-.05,1.476,12.95,1.075,21.733,1.236,26,0,.107-.161.132-.17.021",
    transform: "translate(97.933 122.546)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87462",
    "data-name": "Group 87462",
    transform: "translate(72.521 131.669)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87461",
    "data-name": "Group 87461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87460",
    "data-name": "Group 87460",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275716",
    "data-name": "Path 275716",
    d: "M71.9,90.664c-6.984,1.009-16.32,1.8-21.691-.029C38.84,86.756,22.1,51.66,19.8,45.888c-3.775-9.477-2.762-15.22,2.535-13.839.165.041.331.091.5.149Z",
    transform: "translate(-17.539 -31.844)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275717",
    "data-name": "Path 275717",
    d: "M65.521,97.737c-1.29,1.253-56.506,7-56.779,6.628-.732-1,9.585-52.814,31.7-70.668,3.9-3.147,10.395-1.823,13.335.066,1.472.947,5.541,8.385,6.711,15s5.847,48.175,5.036,48.973",
    transform: "translate(27.289 99.707)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275718",
    "data-name": "Path 275718",
    d: "M43.62,31.952s6.024,31.3,6.219,32.582-.682,36.134-.682,36.134l-41,5.065s4.635-17.308,4.883-18.139S21.962,58.039,31.3,45.163C39.883,33.329,43.62,31.952,43.62,31.952",
    transform: "translate(25.555 100.162)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87465",
    "data-name": "Group 87465",
    transform: "translate(33.711 132.114)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87464",
    "data-name": "Group 87464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87463",
    "data-name": "Group 87463",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275719",
    "data-name": "Path 275719",
    d: "M43.62,31.952s6.024,31.3,6.219,32.582-.682,36.134-.682,36.134l-41,5.065s4.635-17.308,4.883-18.139S21.962,58.039,31.3,45.163C39.883,33.329,43.62,31.952,43.62,31.952",
    transform: "translate(-8.156 -31.952)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275720",
    "data-name": "Path 275720",
    d: "M19.81,32.392s4.139,27.774,4.259,29.527,3.246,35.535,3.246,35.535l5.061-1.9s-2.824-21.989-3.155-23.9S26.533,49.3,25.648,45.479c-1.4-6.049-5.838-13.087-5.838-13.087",
    transform: "translate(62.101 101.541)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87468",
    "data-name": "Group 87468",
    transform: "translate(81.912 133.932)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87467",
    "data-name": "Group 87467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87466",
    "data-name": "Group 87466",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275721",
    "data-name": "Path 275721",
    d: "M19.81,32.392s4.139,27.774,4.259,29.527,3.246,35.535,3.246,35.535l5.061-1.9s-2.824-21.989-3.155-23.9S26.533,49.3,25.648,45.479c-1.4-6.049-5.838-13.087-5.838-13.087",
    transform: "translate(-19.812 -32.39)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275722",
    "data-name": "Path 275722",
    d: "M57.733,79.882,23.707,83.356,35.14,38.084,69.165,34.61Z",
    transform: "translate(74.318 108.496)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275723",
    "data-name": "Path 275723",
    d: "M49.195,36.543c1.914,3.639,6.537,8.067,7.025,11.081A3.508,3.508,0,0,1,54.425,51.4S57.51,52.789,57.5,55.6c0,1.447-2.32,2.712-2.32,2.712a4.179,4.179,0,0,1,2.266,3.713c-.132,1.993-2.431,2.96-2.431,2.96s1.782,2.249,1,4.238c-1.584,4.027-18.694,4.726-21.6-1.468-1.352-2.89,2.836-2.832,2.836-2.832s-6-1.534-6.235-5.061,5.2-3.122,5.2-3.122-5.805-1.538-5.677-5.214c.128-3.829,5.5-2.5,5.5-2.5s-3.912-2.423-3.167-5.214c1.22-4.614,8.658.819,12.384-.227L47.082,37.3Z",
    transform: "translate(95.751 114.554)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275724",
    "data-name": "Path 275724",
    d: "M40.3,48.364c-1.509-3.6,2.836-8.307,1.885-11.958-1.282-4.945-6.694.174-7.645,7.467l.256,5.789Z",
    transform: "translate(108.292 107.98)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275725",
    "data-name": "Path 275725",
    d: "M49.85,43.923a.045.045,0,0,1,.021.087A29.7,29.7,0,0,1,32.2,43.679c-.178-.062-.153-.385.058-.351a60.893,60.893,0,0,0,17.59.6",
    transform: "translate(100.579 135.816)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275726",
    "data-name": "Path 275726",
    d: "M51.258,43.15c.066-.008.083.1.012.12a27.809,27.809,0,0,1-19.252-1.559c-.207-.1-.289-.405-.041-.3,4.176,1.708,13.79,2.435,19.281,1.741",
    transform: "translate(99.762 129.742)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275727",
    "data-name": "Path 275727",
    d: "M31.892,39.483c5.917,2.679,12.094,3.2,18.52,2.812.083,0,.083.116.012.141-3.093,1.042-7.211.86-10.4.447A17.142,17.142,0,0,1,31.8,39.69c-.1-.07-.033-.265.1-.207",
    transform: "translate(99.533 123.737)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275728",
    "data-name": "Path 275728",
    d: "M35.494,41.156C19.037,59.738.6,90.968,8.7,97.5c7.41,5.971,34.154-.087,50.933-6.864,3.192-1.29-4.23-29.808-7.778-28.824-6.124,1.7-15.791,5.826-16.221,5.946-.922.265,3.5-10.825,8.931-24.267,6.062-14.993.331-12.963-9.076-2.34",
    transform: "translate(21.099 102.569)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275729",
    "data-name": "Path 275729",
    d: "M54.348,44.965A4.341,4.341,0,0,1,52.074,48.4a6.1,6.1,0,0,1,2.233,3.486c.434,2.468-3.246,4.238-3.246,4.238a7.487,7.487,0,0,1,1.77,4.052c.178,2.406-3.279,4.718-3.279,4.718a6.582,6.582,0,0,1-.691,4.54c-2.2,3.61-23.49,6.372-26.376,6.624L17.358,46.342s18.119-9.055,22.956-8.472c4.077.488,14.422,2.717,14.034,7.1",
    transform: "translate(54.414 118.627)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275730",
    "data-name": "Path 275730",
    d: "M35.81,42.341c-4.209-1.563-8.782-2.113-13.2-2.6a.077.077,0,0,0-.017.153c4.4.43,8.795,2.047,13.169,2.65a.108.108,0,0,0,.05-.207",
    transform: "translate(70.616 124.588)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275731",
    "data-name": "Path 275731",
    d: "M35.25,42.615a11.707,11.707,0,0,0-3.035-.389q-1.625-.1-3.25-.136c-2.171-.058-4.342-.066-6.512-.008-.1,0-.116.149-.017.153,2.163.062,4.325.153,6.483.306,1.079.074,2.163.157,3.242.252a14.037,14.037,0,0,0,3.06.116.154.154,0,0,0,.029-.294",
    transform: "translate(70.13 131.794)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275732",
    "data-name": "Path 275732",
    d: "M34.019,44.691a8.172,8.172,0,0,0-2.75-.207q-1.489-.006-2.969-.029c-1.981-.033-3.957-.066-5.933-.17-.1,0-.116.149-.017.153,2.01.116,4.015.256,6.024.351.984.045,1.972.087,2.956.124a7.732,7.732,0,0,0,2.692-.124.055.055,0,0,0,0-.1",
    transform: "translate(69.856 138.827)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275733",
    "data-name": "Path 275733",
    d: "M44.3,33.413C32.326,40.8,1.53,84.268,7.2,96.23s44.28-1.212,44.28-1.212L48.063,62.543s-10.155,5.714-10.494,5.2S43.147,52.4,45.557,46.364s5.111-16.882-1.261-12.95",
    transform: "translate(20.405 102.116)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87471",
    "data-name": "Group 87471",
    transform: "translate(26.914 134.691)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87470",
    "data-name": "Group 87470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87469",
    "data-name": "Group 87469",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275734",
    "data-name": "Path 275734",
    d: "M44.3,33.413C32.326,40.8,1.53,84.268,7.2,96.23s44.28-1.212,44.28-1.212L48.063,62.543s-10.155,5.714-10.494,5.2S43.147,52.4,45.557,46.364s5.111-16.882-1.261-12.95",
    transform: "translate(-6.509 -32.575)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275735",
    "data-name": "Path 275735",
    d: "M18.654,66.974c-.715-4.288-3-21.948-3.233-25.8-.017-.269.149-.343.2-.066,2.448,12.8,2.712,21.588,3.2,25.83.012.1-.153.141-.17.033",
    transform: "translate(48.338 128.324)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275736",
    "data-name": "Path 275736",
    d: "M34.857,39.84a23.475,23.475,0,0,0-3.262,1.5c-.955.476-1.91.955-2.857,1.447-2.059,1.071-4.093,2.183-6.12,3.316s-4.036,2.282-6.029,3.465-3.916,2.473-5.9,3.659c-.1.054,0,.186.091.136C12.8,52.211,14.9,51.2,16.953,50.1l6.029-3.238c2.01-1.075,4.023-2.138,6.029-3.221.984-.529,1.96-1.067,2.94-1.6a25.75,25.75,0,0,0,3.109-1.8.228.228,0,0,0-.2-.4",
    transform: "translate(33.372 124.852)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275737",
    "data-name": "Path 275737",
    d: "M21.318,39.823c-.624.8-1.236,1.6-1.819,2.427-.1.153-.2.31-.306.467.157-.426.314-.852.476-1.278a44.3,44.3,0,0,0,1.608-4.507.064.064,0,0,0-.12-.041,44.975,44.975,0,0,0-2.03,4.565c-.637,1.5-1.286,2.989-1.89,4.495S16,48.965,15.426,50.483a32.376,32.376,0,0,0-1.546,4.548c-.021.087.108.124.153.05a34.618,34.618,0,0,0,2.092-4.536c.624-1.5,1.207-3.023,1.811-4.532.252-.633.492-1.269.732-1.91.108-.145.211-.289.314-.43.289-.393.562-.806.827-1.22.546-.852,1.054-1.72,1.559-2.6.012-.029-.029-.058-.05-.033",
    transform: "translate(43.503 115.541)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275738",
    "data-name": "Path 275738",
    d: "M40.373,47.644c-.021-.215-.132-.26-.17-.029-.021.128-.037.36-.058.488-1.319.351-6.124,1.819-7.3,2.171q-3.7,1.092-7.455,1.927-3.777.837-7.592,1.435c-2.531.4-5.1.81-7.654.976a.081.081,0,0,0,.008.161c2.613-.136,5.2-.211,7.8-.509,2.543-.294,5.078-.719,7.583-1.245,2.551-.533,5.086-1.187,7.579-1.948,1.245-.38,2.485-.794,3.713-1.228a18.781,18.781,0,0,0,3.473-1.4.274.274,0,0,0,.12-.244c-.017-.186-.037-.368-.054-.554",
    transform: "translate(31.581 148.779)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275739",
    "data-name": "Path 275739",
    d: "M27.249,50.624c-3.184.695-8.547-4.234-10.631-8.2-.141-.273,1.158-11.011,1.195-13.165,0-.442,13.475,3.51,13.475,3.51a34.366,34.366,0,0,0-1.447,8.253c0,.314.484,8.923-2.593,9.6",
    transform: "translate(52.061 91.625)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275740",
    "data-name": "Path 275740",
    d: "M30.063,32.744l-.008.008c-.021.066-.1.331-.215.753-.2.719-.5,1.894-.753,3.233A24.462,24.462,0,0,0,28.612,41c-.008.1,0,.2,0,.3v.045c.012.178.017.413.017.691a8.348,8.348,0,0,1-1.315.054C19.957,41.8,17.629,32.715,17,29.238c.079.008.153.025.236.041.356.062.823.17,1.385.3.141.037.281.074.434.108.9.223,1.968.513,3.085.806.364.1.732.2,1.1.306.8.227,1.6.451,2.353.657.323.1.641.19.939.269.331.091.657.19.959.269.149.045.3.091.438.128.074.025.141.045.207.062l1.116.323c.223.066.4.12.533.153.112.037.19.054.227.074l.037.008Z",
    transform: "translate(53.295 91.654)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275741",
    "data-name": "Path 275741",
    d: "M17.354,30.5c-1.865,4.652-.521,18.66,2.617,22.022,4.552,4.879,12.586,5.991,16.887.4,4.164-5.425,2.084-23.647-1.476-26.765-5.243-4.594-15.27-2.522-18.028,4.346",
    transform: "translate(51.734 74.274)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275742",
    "data-name": "Path 275742",
    d: "M20.369,27.576c-.012-.033-.07.054-.062.091.145.939.149,2.038-.666,2.452-.025.012-.017.062.012.054,1.025-.273,1-1.732.715-2.6",
    transform: "translate(61.525 86.42)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275743",
    "data-name": "Path 275743",
    d: "M20.364,27.358c-1.53.066-1.282,3.118.132,3.056,1.4-.058,1.149-3.114-.132-3.056",
    transform: "translate(60.571 85.757)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275744",
    "data-name": "Path 275744",
    d: "M21.149,27.509c0-.037.079.037.079.079.045.947.26,2.026,1.141,2.27.025.008.029.054,0,.054-1.054-.062-1.323-1.5-1.216-2.4",
    transform: "translate(66.228 86.201)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275745",
    "data-name": "Path 275745",
    d: "M21.907,27.256c1.513-.24,1.877,2.8.476,3.023-1.377.219-1.741-2.824-.476-3.023",
    transform: "translate(66.235 85.399)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275746",
    "data-name": "Path 275746",
    d: "M19.955,28.764a11.875,11.875,0,0,0,1.149-.513,2.014,2.014,0,0,0,1.071-.744.653.653,0,0,0-.165-.773,1.605,1.605,0,0,0-1.629-.033,2.361,2.361,0,0,0-1.274,1.125.692.692,0,0,0,.848.939",
    transform: "translate(59.661 83.053)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275747",
    "data-name": "Path 275747",
    d: "M23.549,28.317a11.432,11.432,0,0,1-1.24-.215,2.057,2.057,0,0,1-1.22-.463.652.652,0,0,1-.025-.79,1.6,1.6,0,0,1,1.567-.43,2.362,2.362,0,0,1,1.509.781.69.69,0,0,1-.591,1.116",
    transform: "translate(65.652 82.706)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275748",
    "data-name": "Path 275748",
    d: "M19.835,29.719c.244.2.5.488.839.492a2.459,2.459,0,0,0,1-.323c.029-.012.062.017.045.045a1.275,1.275,0,0,1-1.158.612,1.011,1.011,0,0,1-.81-.777c-.021-.054.05-.079.087-.05",
    transform: "translate(61.894 93.124)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275749",
    "data-name": "Path 275749",
    d: "M19.969,37.037a3.229,3.229,0,0,0,2.266,1.257,4.063,4.063,0,0,0,1.162-.037,1.288,1.288,0,0,0,.219-.045,1.436,1.436,0,0,0,.2-.05.234.234,0,0,0,.174-.223V37.93l-.017-.1v-.008l-.008-.083c-.041-.732-.2-1.832-.2-1.832.277.112,1.683.612,1.633.236a48.424,48.424,0,0,0-2.038-9.642.087.087,0,0,0-.17.037c.306,3.027,1.141,5.983,1.5,9.018a5.738,5.738,0,0,0-1.555-.339c-.1.037.347,2.125.339,2.452l0,.037a4.476,4.476,0,0,1-3.415-.765c-.074-.05-.145.021-.083.091",
    transform: "translate(62.525 82.896)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275750",
    "data-name": "Path 275750",
    d: "M23.139,29.91A3.889,3.889,0,0,1,21.7,31.22a1.769,1.769,0,0,1-1.042.149c-.765-.141-.839-.831-.753-1.435A4.231,4.231,0,0,1,20.174,29a4.971,4.971,0,0,0,2.965.91",
    transform: "translate(62.324 90.908)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275751",
    "data-name": "Path 275751",
    d: "M21.706,30.508a1.694,1.694,0,0,1-1.038.149c-.773-.136-.848-.827-.757-1.431a1.777,1.777,0,0,1,1.795,1.282",
    transform: "translate(62.322 91.616)",
    fill: "#ffe7cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87474",
    "data-name": "Group 87474",
    transform: "translate(78.316 105.948)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87473",
    "data-name": "Group 87473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87472",
    "data-name": "Group 87472",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275752",
    "data-name": "Path 275752",
    d: "M24.268,26.127a11.471,11.471,0,0,0,1.555.05c.525-.041,1.038-.186,1.563-.211a8.392,8.392,0,0,1,2.927.5c.083.025.07.079-.012.058a7.351,7.351,0,0,0-3.1-.3,9.23,9.23,0,0,1-2.568.153,9.239,9.239,0,0,0-5.681.827l-.012-.017a9.32,9.32,0,0,1,5.326-1.067",
    transform: "translate(-18.936 -24.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275753",
    "data-name": "Path 275753",
    d: "M24.036,25.785a10.984,10.984,0,0,0,1.476.045c.5-.037.98-.174,1.48-.2a7.906,7.906,0,0,1,2.774.48c.079.021.066.074-.012.054a6.927,6.927,0,0,0-2.936-.281,8.884,8.884,0,0,1-2.431.145A8.8,8.8,0,0,0,19,26.81l-.008-.017a8.825,8.825,0,0,1,5.049-1.009",
    transform: "translate(-18.795 -25.623)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275754",
    "data-name": "Path 275754",
    d: "M39.419,35.384c-4.792,3.357-11.453-1.571-11.453-1.571a5.248,5.248,0,0,1-5.293,3.374s-.86,8.17-3.014,8.179c-3.283.017-4.416-11.1-3.4-13.3s3.792-2.787,3.792-2.787a5.361,5.361,0,0,1,2.2-3.271c2.225-1.737,9.986.488,9.986.488A7.193,7.193,0,0,1,34.184,23.8a2.029,2.029,0,0,1,2.923.236,4.874,4.874,0,0,0-.765,2.022c-.364,2.394,1.592,2.369,1.551.2a3.366,3.366,0,0,0-.786-2.225c.951-1.427,2.522-1.9,3.486-1.154,1.749,1.356,2.812,9.713-1.174,12.5",
    transform: "translate(49.835 70.635)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275755",
    "data-name": "Path 275755",
    d: "M22.532,35.636a4.408,4.408,0,1,1,1.087-.091,4.4,4.4,0,0,1-1.087.091m.368-8.2a3.852,3.852,0,0,0-.943.074,3.809,3.809,0,1,0,.943-.074",
    transform: "translate(57.473 84.164)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275756",
    "data-name": "Path 275756",
    d: "M24.287,35.44c-1.679-.079-3.126-1.865-3.291-4.151a5.222,5.222,0,0,1,.707-3.13,2.736,2.736,0,0,1,4.672-.339,5.246,5.246,0,0,1,1.145,3c.174,2.415-1.149,4.486-2.944,4.619-.1,0-.194.008-.289,0m-.079-8.187a1.344,1.344,0,0,0-.223,0A2.344,2.344,0,0,0,22.2,28.469a4.66,4.66,0,0,0-.616,2.774c.149,2.1,1.468,3.713,2.948,3.606s2.555-1.894,2.406-3.99A4.64,4.64,0,0,0,25.925,28.2a2.406,2.406,0,0,0-1.716-.947",
    transform: "translate(65.769 83.583)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275757",
    "data-name": "Path 275757",
    d: "M20.72,28.829l-.409-.422c.624-.608,2.109-1.468,3.262-.4l-.4.434c-1.03-.959-2.394.335-2.452.389",
    transform: "translate(63.671 86.208)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275758",
    "data-name": "Path 275758",
    d: "M16.118,30.837l-.542-.232c.112-.252,1.1-2.468,2.386-2.774,1.212-.285,9.117-.112,9.452-.1l-.012.587c-2.266-.054-8.369-.132-9.3.087-.852.2-1.72,1.828-1.981,2.435",
    transform: "translate(48.828 86.731)",
    fill: "#727375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275759",
    "data-name": "Path 275759",
    d: "M21.652,31.017s-2.836-4.668-4.941-3.688-.17,7.612,2.154,8.65A2.428,2.428,0,0,0,22.2,34.891Z",
    transform: "translate(49.562 85.244)",
    fill: "#ffe4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275760",
    "data-name": "Path 275760",
    d: "M16.2,27.682a.033.033,0,0,0-.021.062A6.115,6.115,0,0,1,19.1,31.78a1.337,1.337,0,0,0-1.976-.5c-.045.029-.008.1.041.091a1.491,1.491,0,0,1,1.6.624,7.065,7.065,0,0,1,.7,1.377c.07.157.343.1.3-.083l-.008-.037c.178-2.125-1.282-5.21-3.552-5.574",
    transform: "translate(50.672 86.776)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275761",
    "data-name": "Path 275761",
    d: "M32,33.977l-3.233,8.042-9.994-10.18-2.832,3.267s9.775,16.171,9.837,15.444l3.316-6.934,4.784,4.825-.385-12.111Z",
    transform: "translate(49.975 99.808)",
    fill: "#ffe7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275762",
    "data-name": "Path 275762",
    d: "M33.721,39.4c-.132-2-.207-4.011-.43-6-.008-.07-.116-.1-.136-.017-.4,1.927.141,9.564.132,11.4l-.021-.021c-.2-.211-4.437-4.246-4.478-4.184-.719,1.1-3.155,6.153-3.32,6.612-1.546-2.572-7.472-11.908-9.3-14.34a.07.07,0,0,0-.12.07c1.364,2.712,9.2,15.291,9.324,15.253a76.794,76.794,0,0,0,3.469-7.331c.719.881,4.991,5.437,5.007,5.14a62.276,62.276,0,0,0-.128-6.574",
    transform: "translate(50.282 102.853)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25345",
    "data-name": "Rectangle 25345",
    width: 65.45,
    height: 146.447,
    transform: "translate(209.867 201.705)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87477",
    "data-name": "Group 87477",
    transform: "translate(209.867 201.706)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87476",
    "data-name": "Group 87476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87475",
    "data-name": "Group 87475",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25346",
    "data-name": "Rectangle 25346",
    width: 65.45,
    height: 146.447,
    transform: "translate(0 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25348",
    "data-name": "Rectangle 25348",
    width: 65.45,
    height: 146.447,
    transform: "translate(24.83 201.705)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25349",
    "data-name": "Rectangle 25349",
    width: 185.037,
    height: 20.343,
    transform: "translate(90.28 201.709)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87480",
    "data-name": "Group 87480",
    transform: "translate(90.283 201.706)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87479",
    "data-name": "Group 87479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87478",
    "data-name": "Group 87478",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25350",
    "data-name": "Rectangle 25350",
    width: 185.037,
    height: 20.343,
    transform: "translate(-0.003 0.003)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87483",
    "data-name": "Group 87483",
    transform: "translate(90.702 211.625)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87482",
    "data-name": "Group 87482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87481",
    "data-name": "Group 87481",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275763",
    "data-name": "Path 275763",
    d: "M21.936,51.43c46.016-.331,138.611-.331,184.615,0-46.012.331-138.611.331-184.615,0",
    transform: "translate(-21.936 -51.181)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25353",
    "data-name": "Rectangle 25353",
    width: 8.807,
    height: 146.447,
    transform: "translate(90.284 201.705)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87486",
    "data-name": "Group 87486",
    transform: "translate(90.285 201.706)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87485",
    "data-name": "Group 87485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87484",
    "data-name": "Group 87484",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25354",
    "data-name": "Rectangle 25354",
    width: 8.807,
    height: 146.447,
    transform: "translate(-0.001 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25356",
    "data-name": "Rectangle 25356",
    width: 8.807,
    height: 146.447,
    transform: "translate(266.514 201.705)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87489",
    "data-name": "Group 87489",
    transform: "translate(266.513 201.706)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87488",
    "data-name": "Group 87488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87487",
    "data-name": "Group 87487",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25357",
    "data-name": "Rectangle 25357",
    width: 8.807,
    height: 146.447,
    transform: "translate(0.001 -0.001)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25359",
    "data-name": "Rectangle 25359",
    width: 53.567,
    height: 2.402,
    transform: "translate(123.689 199.302)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25360",
    "data-name": "Rectangle 25360",
    width: 26.959,
    height: 2.402,
    transform: "translate(150.292 199.302)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275764",
    "data-name": "Path 275764",
    d: "M37.05,75.663h52.2l6.827-35.456h-52.2Z",
    transform: "translate(116.143 126.04)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275765",
    "data-name": "Path 275765",
    d: "M43.428,46.906a2.865,2.865,0,0,0,2.9,3.176,3.536,3.536,0,0,0,3.457-3.176,2.868,2.868,0,0,0-2.9-3.18,3.54,3.54,0,0,0-3.457,3.18",
    transform: "translate(136.101 137.071)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275766",
    "data-name": "Path 275766",
    d: "M89.331,59.022l-2.1,12.619L72.974,148.619h-2.3L81.041,71.641l1.53-12.619Z",
    transform: "translate(221.552 185.021)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275767",
    "data-name": "Path 275767",
    d: "M74.712,59.022h6.76l-2.1,12.619H73.182Z",
    transform: "translate(229.412 185.021)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275768",
    "data-name": "Path 275768",
    d: "M100.157,148.619h-2.3L83.605,71.641,81.5,59.022h6.76l1.53,12.619Z",
    transform: "translate(255.489 185.021)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275769",
    "data-name": "Path 275769",
    d: "M88.261,59.022l1.53,12.619H83.6L81.5,59.022Z",
    transform: "translate(255.488 185.021)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275770",
    "data-name": "Path 275770",
    d: "M110.5,148.619h-2.3L93.946,71.641l-2.1-12.619H98.6l1.53,12.619Z",
    transform: "translate(287.905 185.021)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275771",
    "data-name": "Path 275771",
    d: "M100.131,71.641H93.946l-2.1-12.619H98.6Z",
    transform: "translate(287.905 185.02)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275772",
    "data-name": "Path 275772",
    d: "M174.66,126.767H70.211V115.76h39.1L122.45,39.3h48.229Z",
    transform: "translate(220.097 123.206)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275773",
    "data-name": "Path 275773",
    d: "M102.6,126.767H96.91L93.2,39.3h5.425Z",
    transform: "translate(292.154 123.206)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275774",
    "data-name": "Path 275774",
    d: "M55.348,118.862c1.931,1.129,61.323,13.542,63.887,12.586.976-.36,3.287-8.9,5.789-19.305.542-2.249,1.083-4.573,1.625-6.934,3.519-15.332,6.9-31.685,6.9-31.685L93.839,65.1,88.034,97.022l-1.278,7s-24.867,5.417-27.567,6.769-5.772,6.938-3.841,8.067",
    transform: "translate(171.612 204.078)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275775",
    "data-name": "Path 275775",
    d: "M124.059,85.2c-2.113,8.53-3.978,15.022-4.825,15.34-2.559.959-61.96-11.466-63.887-12.595s1.154-6.7,3.837-8.063c1.666-.831,11.772-3.213,19.268-4.916-6.545,1.563-18.764,6,6.5,7.831,20.889,1.517,34.675,2.208,39.107,2.4",
    transform: "translate(171.613 234.99)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275776",
    "data-name": "Path 275776",
    d: "M68.634,133.343c2.154.6,62.75-2.531,64.983-4.11.852-.6-1.48-24.925-2.113-27.261-2.15-7.926-12.392-31.8-12.392-31.8L78.574,72.147l16.647,38.847s-22.663,11.573-24.929,13.57-3.812,8.179-1.658,8.778",
    transform: "translate(211.93 219.971)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275777",
    "data-name": "Path 275777",
    d: "M133.618,95.42c-2.237,1.584-62.824,4.714-64.987,4.118s-.6-6.789,1.658-8.782c1.063-.934,6.537-3.932,12.09-6.876-6.967,3.924-17.995,12.669,50.606-2.923.624,6.938,1.087,14.145.633,14.464",
    transform: "translate(211.928 253.78)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275778",
    "data-name": "Path 275778",
    d: "M167.445,84.986c-12.078,13.455-52.657,2.828-55.084,8.183-2.134,4.722,25.557,80.55,25.557,80.55l-44.313,4.776S55.354,94.748,69.024,70.555c7.389-13.07,39.93-7.86,59.57-10.25,5.925-.724,8.708-12.938,8.708-12.938h35.092s8.857,22.241-4.949,37.619",
    transform: "translate(207.124 148.485)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275779",
    "data-name": "Path 275779",
    d: "M69.766,63.055l37.209,28.476c12.359-.265,39.409,4.019,48.89-6.549,13.806-15.377,4.954-37.614,4.954-37.614h-35.1s-2.783,12.214-8.7,12.938c-13.785,1.67-33.91-.389-47.253,2.75",
    transform: "translate(218.704 148.485)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275780",
    "data-name": "Path 275780",
    d: "M72.383,79.7c1.224-.385,12.715-1.666,15.249-1.939,5.069-.546,21.042-2.039,23.932-2.03a.07.07,0,0,1,.017.136c-2.514.525-12.706,1.716-15.241,1.976-5.078.521-22.526,2.212-23.936,2.072a.109.109,0,0,1-.021-.215",
    transform: "translate(226.651 237.395)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275781",
    "data-name": "Path 275781",
    d: "M76.116,86.706c2.849-1.418,24.445-.715,39.942-2.167,5.053-.476,10.114-1.551,13.972-4.858a23.1,23.1,0,0,0,6.9-11.362c1.489-5.293,1.336-10.817,1.079-16.242-.062-1.336-.153-2.667-.236-4-.008-.074.132-.091.141-.012,1.178,9.713,2.08,20.567-4.238,28.989a20.333,20.333,0,0,1-11.3,7.41c-9.349,2.456-44.486,1.848-45.727,2.8-1.476,1.129,21.241,70.3,21.691,71.611.083.248-.347.418-.455.17-2.241-5.3-24.251-71.1-21.77-72.33",
    transform: "translate(237.998 150.502)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275782",
    "data-name": "Path 275782",
    d: "M67.841,61.024c2.088-5.3,6.856-8.6,13.864-9.87.12-.021.112.153,0,.186-6.115,1.786-10.49,4.246-12.9,9.411-1.121,2.411-1.7,5.8-1.993,10.337-1.455,22.646,18.3,74.055,18.706,74.948a.069.069,0,0,1-.12.066c-2.783-4.689-26.182-63.188-17.556-85.078",
    transform: "translate(206.719 160.352)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275783",
    "data-name": "Path 275783",
    d: "M62.528,151.963,96.082,159.1S69.611,80.091,82.044,69.9c3.444-2.824,10.957-3.812,19.888.045,13.331,5.756,28.762,17.5,43.308,21.79,13.624,4.023,29.8.323,35.365-5.805,11.693-12.868,2.9-37.193,2.9-37.193l-48.253-1.811s.719.583-1.584,2.626c0,0-28.365-6.43-40.687,1.1C70.752,64.234,62.528,151.963,62.528,151.963",
    transform: "translate(196.014 147.103)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275784",
    "data-name": "Path 275784",
    d: "M87.148,48.09a.087.087,0,0,1,.17.029,26.937,26.937,0,0,0,.418,5.408,9.324,9.324,0,0,0,2.427,4.495C92.8,60.7,96.6,61.611,100.069,62.7c.182.058.149.38-.054.351-3.85-.591-7.9-1.567-10.709-4.453a9.379,9.379,0,0,1-2.489-4.846,11.589,11.589,0,0,1,.331-5.665",
    transform: "translate(271.523 150.57)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275785",
    "data-name": "Path 275785",
    d: "M71.387,53.326c5.16-3.238,13.223-.777,17.085.7.079.029.041.161-.041.128-3.552-1.278-12.388-3.209-17.114.136-10.916,7.736,3.7,60.629,13.277,89.738.149.455-.211.335-.413-.1-1.579-3.448-13.93-40.236-17.151-64.569-.5-3.742-3.08-21.365,4.358-26.033",
    transform: "translate(207.502 162.171)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275786",
    "data-name": "Path 275786",
    d: "M63.533,70.171c1.013-.025,9.709,1.89,11.623,2.324,3.833.86,12.715,3.159,14.786,3.953.054.021.021.136-.037.128-1.993-.19-6.62-1.2-8.53-1.646-3.829-.889-16.944-4.04-17.9-4.552-.083-.046-.037-.2.062-.207",
    transform: "translate(198.834 219.971)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275787",
    "data-name": "Path 275787",
    d: "M67.861,64.388a19.072,19.072,0,0,1,11.458-1.732,40.037,40.037,0,0,1,11.706,3.663c7.848,3.589,15.328,7.972,23.184,11.54,7.815,3.552,16.159,6.33,24.768,6.6,7.364.223,16.68-1.071,21.414-7.695,7.29-10.2,3.043-27.794,2.956-28.927,0-.091.116-.087.136,0,5.656,21.625-1.621,30.019-6.533,33.55-3.9,2.8-9.51,3.51-13.211,3.825-8.567.724-17.155-1.377-25.094-4.536-8.137-3.242-15.77-7.608-23.564-11.594C87.6,65.253,79.269,61.308,70.735,63.5a20.924,20.924,0,0,0-2.841.972c-.045.017-.074-.058-.033-.083",
    transform: "translate(212.67 149.736)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275788",
    "data-name": "Path 275788",
    d: "M80.2,63.47c-.128,10.85-.074,22.01,1.464,32.764,1.2,8.373,5.036,15.146,13.868,16.833,8.2,1.555,19.74.906,26.368-4.772,3.085-2.646,4.044-6.231,3.655-10.184-.533-5.5-6.219-35.489-7.935-44.842-1.034-5.7-2.055-11.478-4.1-16.936-4.28-11.458-10.027-11.11-10.833-11.309-.707-.413-5.21-2.187-11.4.087a12.272,12.272,0,0,0-7.174,6.971C80.006,41.6,80.32,53.311,80.2,63.47",
    transform: "translate(251.259 75.156)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275789",
    "data-name": "Path 275789",
    d: "M86.11,24.6c7.058,2.932,9.035,10.411,11.007,17.106,2.741,9.32,5.326,18.689,7.455,28.171,1.021,4.561,1.943,9.142,2.725,13.748.752,4.408,1.823,9.1,1.72,13.591-.17,7.426-6.8,11.094-13.314,12.433a.253.253,0,0,1-.12-.492c3.709-.9,7.48-2.109,10.139-5,3.415-3.713,2.8-8.336,2.175-12.942-1.063-7.835-2.568-15.6-4.354-23.308s-3.849-15.361-6.029-22.969c-2.072-7.244-3.767-16.825-11.441-20.215-.07-.033-.037-.149.037-.12",
    transform: "translate(269.7 77.108)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275790",
    "data-name": "Path 275790",
    d: "M82.2,37.937c1.067-5.714,3.767-11.358,9.651-13.264l0,.021c-7.592,2.787-9.1,11.284-9.82,18.359Q80.9,54.222,80.593,65.446c-.2,7.195-.248,14.443.207,21.629.488,7.757,2.212,14.964,7.075,21.162.1.128-.07.3-.186.178-4.743-4.978-6.55-12.045-7.2-18.7a201.413,201.413,0,0,1-.376-26.529c.289-8.356.55-17.011,2.088-25.247",
    transform: "translate(250.337 77.344)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275791",
    "data-name": "Path 275791",
    d: "M136.064,46.941c-10.68,13.128-25.289,25.532-31.4,25.33-4.937-.161-34.488-17.891-36.572-20.583-1.79-2.316,12.107-20.232,14.985-19,4.834,2.067,22.01,16.275,23.473,16.055,1.517-.232,13.5-5.462,25.47-11.1,11.458-5.392,11.466.174,4.048,9.291",
    transform: "translate(212.944 102.291)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275792",
    "data-name": "Path 275792",
    d: "M85.843,64.919c-2.373-1.336-12.7-8.423-15.138-11.036s-8.89-10.647-7.079-12.715,3.9.132,3.9.132-2.191-3.821-.178-5.735,5.135,1.613,5.135,1.613-1.96-4.089.186-5.855,4.689,2.307,4.689,2.307-1.968-3.655.413-4.366c2.861-.856,5.731,6.3,8.633,8.981.657.612,14.244,11.408,14.244,11.408Z",
    transform: "translate(198.467 91.516)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275793",
    "data-name": "Path 275793",
    d: "M66.858,30.3c2.121,5.255,3.957,7.186,8.485,10.445.091.062.017.207-.083.149-4.726-2.787-7.377-4.875-8.662-10.5-.062-.277.161-.343.26-.091",
    transform: "translate(208.736 94.5)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275794",
    "data-name": "Path 275794",
    d: "M65.691,31.113c2.679,5.264,4.656,7.377,9.146,11.139.062.054-.021.165-.091.116-4.714-3.32-7.31-5.466-9.3-11.077-.091-.256.12-.418.244-.178",
    transform: "translate(205.094 97.164)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275795",
    "data-name": "Path 275795",
    d: "M64.543,32.313c2.965,4.908,5.028,7.319,9.857,10.411a.1.1,0,0,1-.1.182A19.012,19.012,0,0,1,64.4,32.42c-.141-.331-.045-.418.141-.108",
    transform: "translate(201.677 100.69)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275796",
    "data-name": "Path 275796",
    d: "M87.055,48.072s-2.287-6.723-3.94-9.452-11.569-10.639-13.4-8.6c-2.361,2.642,2.464,8.332,5.189,10.813,0,0-5.47,6.1-2.89,10.937s15.042-3.7,15.042-3.7",
    transform: "translate(216.56 93.072)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275797",
    "data-name": "Path 275797",
    d: "M69.338,30.014C68.92,33.975,72.712,37,75.176,39.6a.329.329,0,0,1-.087.533c-2.121,2.708-4.325,7.149-3.258,10.622a.083.083,0,0,1-.153.062c-1.65-3.568.157-8.108,2.671-10.928-2.568-2.63-6.235-5.83-5.049-9.882,0-.025.041-.021.037,0",
    transform: "translate(216.523 94.021)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275798",
    "data-name": "Path 275798",
    d: "M87.907,36.216,69.561,58.932s24.366,13.095,30.713,11.9,14.2-6.707,30-24.8c12.508-14.34,2.609-14.464-5.185-10.548-6.372,3.2-22.555,10.494-23.837,9.924s-13.343-9.192-13.343-9.192",
    transform: "translate(218.061 104.358)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275799",
    "data-name": "Path 275799",
    d: "M69.562,58.936S91.6,70.782,99.213,70.914a5.592,5.592,0,0,0,1.058-.074c6.343-1.2,14.207-6.711,30.006-24.813,5.528-6.343,6.678-9.9,5.57-11.565-1.414-2.084-6.409-1.166-10.763,1.021-6.363,3.2-22.551,10.5-23.837,9.924s-13.335-9.192-13.335-9.192Z",
    transform: "translate(218.064 104.359)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275800",
    "data-name": "Path 275800",
    d: "M87.447,35.265c-2.485,3.519-5.14,6.926-7.852,10.267-1.336,1.642-2.667,3.287-4.06,4.875-1.451,1.658-3,3.229-4.441,4.891-.066.074-.186-.017-.124-.1,1.381-1.7,2.642-3.506,3.986-5.239,1.294-1.67,2.638-3.3,3.969-4.945,2.712-3.349,5.441-6.694,8.27-9.948a.159.159,0,0,1,.252.194",
    transform: "translate(222.424 109.754)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275801",
    "data-name": "Path 275801",
    d: "M82.777,77.511l-.591,12.276s14.509,1.592,50.391,1.592c0,0-7.567-38.3-19.711-52.558-6.074-7.133-13.542-6.909-18.474-2.278-1.249,1.17-12.818,20.562-14.608,27.74-1.563,6.33,2.994,13.227,2.994,13.227",
    transform: "translate(249.083 104.191)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275802",
    "data-name": "Path 275802",
    d: "M89.673,35.012C87.3,44.158,82.28,53.4,82.652,62.914c.434,3.229,1.985,6.264,3.527,9.055q-.378,6.488-1,12.967-.025-6.506.194-13c-1.331-1.5-3.188-5.954-3.63-8.877-.4-9.853,4.825-18.937,7.931-28.042",
    transform: "translate(256.18 109.754)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275803",
    "data-name": "Path 275803",
    d: "M81.965,38.487a.8.8,0,0,0,.633.9A.733.733,0,0,0,83.4,38.7a.8.8,0,0,0-.633-.9.73.73,0,0,0-.806.686",
    transform: "translate(256.928 118.473)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275804",
    "data-name": "Path 275804",
    d: "M81.275,40.667a.8.8,0,0,0,.633.9.733.733,0,0,0,.806-.691.8.8,0,0,0-.633-.9.732.732,0,0,0-.806.686",
    transform: "translate(254.765 125.307)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275805",
    "data-name": "Path 275805",
    d: "M81.275,42.857a.8.8,0,0,0,.633.9.733.733,0,0,0,.806-.691.8.8,0,0,0-.633-.9.729.729,0,0,0-.806.686",
    transform: "translate(254.765 132.172)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275806",
    "data-name": "Path 275806",
    d: "M81.965,44.639a.8.8,0,0,0,.633.9.733.733,0,0,0,.806-.691.8.8,0,0,0-.633-.9.73.73,0,0,0-.806.686",
    transform: "translate(256.928 137.758)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275807",
    "data-name": "Path 275807",
    d: "M81.819,46.625a.8.8,0,0,0,.633.9.733.733,0,0,0,.806-.691.8.8,0,0,0-.633-.9.73.73,0,0,0-.806.686",
    transform: "translate(256.471 143.984)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275808",
    "data-name": "Path 275808",
    d: "M87.241,36.864c-1.224,2.055-2.361,4.16-3.469,6.277.269-1,.6-1.985.935-2.961.029-.079-.1-.128-.132-.054A13.861,13.861,0,0,0,83.4,43.852c-.356.686-.724,1.369-1.075,2.063-.691,1.381-1.393,2.754-1.952,4.2a14.6,14.6,0,0,0-.926,4.524c-.008.083.132.1.141.017a16.128,16.128,0,0,1,1.447-4.507c.624-1.426,1.327-2.824,2.01-4.226,1.455-2.989,2.9-5.983,4.271-9.014a.043.043,0,0,0-.074-.041",
    transform: "translate(249.051 115.49)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275809",
    "data-name": "Path 275809",
    d: "M113.374,38.879c7.856,13.608,21.733,41.58,17.085,49.32-4.61,7.674-30.788,12.748-39.731,14.335-2.944.521-13.579-20.467-10.651-21.757,4.966-2.2,28.559-6.479,29.312-8.079.476-1-4.151-19.334-4.7-30.118-.711-14.013,6.244-7.926,8.683-3.7",
    transform: "translate(249.443 106.148)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275810",
    "data-name": "Path 275810",
    d: "M110.748,45s-9.279,1.29-15.307,2.423c-3.366.628-9.035,2.225-11.292,3.816C80.771,53.622,68.16,65.745,71.033,68.867c2.6,2.824,12.111-8.968,12.111-8.968S72.5,70.951,76.255,73.775,88.987,61.846,88.987,61.846s-10.688,11.6-6.351,13.9c3.275,1.741,12.156-11.164,12.156-11.164S85.675,74.619,88.97,76.55c3.639,2.138,12.582-9.262,12.582-9.262,9.2,3.506,15.014,1.414,18.971-.566.959-.48-9.775-21.724-9.775-21.724",
    transform: "translate(221.352 141.056)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275811",
    "data-name": "Path 275811",
    d: "M82.6,47.628c-1.3,1.253-2.621,2.514-3.8,3.874s-2.315,2.77-3.366,4.238a30.655,30.655,0,0,0-3.539,6.1,66.316,66.316,0,0,1,7.294-10.027c1.178-1.36,2.291-2.783,3.469-4.147.029-.033-.025-.07-.054-.041",
    transform: "translate(225.34 149.27)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275812",
    "data-name": "Path 275812",
    d: "M82.473,48.637c-1.588,1.67-3.225,3.271-4.743,5.016s-2.783,3.51-4.168,5.342c-.107.141,0,.153.116.017,1.46-1.778,2.94-3.308,4.416-5.065s2.886-3.577,4.42-5.276c.025-.025-.017-.058-.041-.033",
    transform: "translate(230.467 152.438)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275813",
    "data-name": "Path 275813",
    d: "M81.953,49.322a51.391,51.391,0,0,0-6.661,8.224c-.1.145.045.141.153,0,2.167-2.774,3.841-4.97,6.6-8.137.041-.046-.033-.136-.087-.087",
    transform: "translate(235.923 154.568)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275814",
    "data-name": "Path 275814",
    d: "M80.115,80.016,98.97,103.345s27.282-6.252,31.164-15.559-9.274-35.464-16.548-46.293-11.879-10.564-11.032,1.848c.761,11.119,4.879,28.985,4.449,29.6s-26.889,7.079-26.889,7.079",
    transform: "translate(251.146 105.586)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275815",
    "data-name": "Path 275815",
    d: "M82.046,44.826c2.936,3.151,5.731,6.446,8.447,9.787,1.336,1.637,2.671,3.283,3.94,4.97,1.323,1.757,2.547,3.6,3.879,5.346.062.079-.054.178-.116.1-1.381-1.7-2.894-3.3-4.313-4.97-1.373-1.608-2.7-3.258-4.031-4.9-2.725-3.341-5.441-6.7-8.046-10.13a.158.158,0,0,1,.24-.207",
    transform: "translate(256.335 140.346)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275816",
    "data-name": "Path 275816",
    d: "M80.158,64.02c2.1-.17,27.129-6.587,27.157-6.6.05-.029-1.216-7.947-1.48-9.444q-.8-4.59-1.794-9.146c-.008-.066-.132-.062-.124.008.145,1.848.351,3.7.6,5.537-.277-.8-.579-1.6-.926-2.373-.029-.066-.136-.021-.116.045.413,1.559.889,3.109,1.365,4.648.066.409.1.815.17,1.224q.378,2.3.815,4.594c.149.748.724,3.668.86,4.449-3.324.653-24.623,6.153-26.554,6.9-.07.029-.046.165.033.157",
    transform: "translate(251.049 121.59)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275817",
    "data-name": "Path 275817",
    d: "M93.214,46.81a7.6,7.6,0,0,1-1.307,2.005c-.074.066.021.087.112.021a3.748,3.748,0,0,0,1.232-1.972c.008-.05-.012-.1-.037-.054",
    transform: "translate(288.029 146.682)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275818",
    "data-name": "Path 275818",
    d: "M95.48,45.763c-.149.947-4.135,7.335-8.41,7.459-1.393.037-1.939-7.55-1.939-7.55l-.165-.554L82.612,37.4l8.77-6.616,1.274-.881s.5,2.15,1.1,4.838q.043.186.087.385c.037.149.074.294.1.434.1.4.19.81.277,1.22.066.31.132.616.19.943s.128.649.194.98a51.731,51.731,0,0,1,.868,7.058",
    transform: "translate(258.973 93.748)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275819",
    "data-name": "Path 275819",
    d: "M93.759,34.748a16.186,16.186,0,0,1-8.795,10.374l-2.353-7.716,8.77-6.616,1.274-.885s.5,2.154,1.1,4.842",
    transform: "translate(258.973 93.748)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275820",
    "data-name": "Path 275820",
    d: "M80.049,40.683c-1.766,14.046,6.446,16.688,9.477,17.064,2.75.343,12.152,1.162,15.361-12.628s-2.762-19.045-9.01-20.161S81.814,26.637,80.049,40.683",
    transform: "translate(250.166 77.546)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275821",
    "data-name": "Path 275821",
    d: "M80.971,28.778c.331,0,.645-.054.98-.083a1.626,1.626,0,0,0,.984-.277.511.511,0,0,0,.07-.616,1.262,1.262,0,0,0-1.195-.442,1.866,1.866,0,0,0-1.228.509.542.542,0,0,0,.389.91",
    transform: "translate(252.13 85.751)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275822",
    "data-name": "Path 275822",
    d: "M84.242,29.275a9.132,9.132,0,0,1-.93-.318,1.6,1.6,0,0,1-.889-.509.507.507,0,0,1,.079-.612,1.249,1.249,0,0,1,1.265-.141,1.846,1.846,0,0,1,1.071.79.541.541,0,0,1-.6.79",
    transform: "translate(258.162 86.494)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275823",
    "data-name": "Path 275823",
    d: "M82.346,28.81c.012-.037.07.058.062.1-.174.955-.207,2.076.616,2.522.025.017.012.062-.017.054-1.038-.306-.976-1.795-.662-2.671",
    transform: "translate(257.503 90.287)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275824",
    "data-name": "Path 275824",
    d: "M83.3,28.593c1.559.108,1.228,3.221-.219,3.122-1.422-.1-1.087-3.213.219-3.122",
    transform: "translate(257.552 89.627)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275825",
    "data-name": "Path 275825",
    d: "M82.73,28.666c.252.207.488.546.81.612.376.079.695-.215.976-.5.033-.029.054,0,.05.041-.054.6-.347,1.187-1,1.207-.591.017-.955-.554-1.038-1.17-.017-.116.1-.269.2-.186",
    transform: "translate(258.715 89.787)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275826",
    "data-name": "Path 275826",
    d: "M81.9,28.614c0-.037-.079.037-.083.079-.066.968-.3,2.063-1.207,2.3-.029.008-.029.054,0,.054C81.692,31,81.994,29.54,81.9,28.614",
    transform: "translate(252.628 89.665)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275827",
    "data-name": "Path 275827",
    d: "M81.794,28.355c-1.542-.273-1.972,2.828-.546,3.08,1.406.248,1.836-2.853.546-3.08",
    transform: "translate(251.972 88.832)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275828",
    "data-name": "Path 275828",
    d: "M81.809,28.666c-.269.132-.55.4-.848.372-.343-.025-.546-.393-.719-.744-.017-.037-.045-.017-.05.025-.1.591.008,1.236.562,1.431.5.174.959-.281,1.183-.852.041-.107-.021-.285-.128-.232",
    transform: "translate(251.284 88.633)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275829",
    "data-name": "Path 275829",
    d: "M83.43,30.675c-.244.211-.5.509-.848.517a2.519,2.519,0,0,1-1.025-.306c-.033-.012-.066.017-.045.045a1.3,1.3,0,0,0,1.195.6,1.039,1.039,0,0,0,.815-.81c.017-.054-.054-.079-.091-.05",
    transform: "translate(255.505 96.121)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275830",
    "data-name": "Path 275830",
    d: "M82.345,36.786s-.368,1.414-.451,2.092c-.008.066.153.116.38.153l.029,0a3.239,3.239,0,0,0,3.275-.831c.054-.058-.025-.141-.091-.1a4.9,4.9,0,0,1-3.043.492c-.025-.194.711-2.4.608-2.423a6.09,6.09,0,0,0-1.584.165c.686-2.969,1.84-5.8,2.477-8.77a.092.092,0,0,0-.17-.066A49.232,49.232,0,0,0,80.7,36.831c-.1.38,1.356.037,1.642-.045",
    transform: "translate(252.976 86.054)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275831",
    "data-name": "Path 275831",
    d: "M81.122,30.737a3.877,3.877,0,0,0,1.336,1.414,1.739,1.739,0,0,0,1.03.223c.777-.079.906-.765.86-1.377a4.1,4.1,0,0,0-.2-.951,4.991,4.991,0,0,1-3.027.691",
    transform: "translate(254.303 94.187)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275832",
    "data-name": "Path 275832",
    d: "M81.446,31.429a1.719,1.719,0,0,0,1.021.223c.782-.079.906-.765.86-1.373a1.777,1.777,0,0,0-1.881,1.149",
    transform: "translate(255.318 94.909)",
    fill: "#ffe7cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275833",
    "data-name": "Path 275833",
    d: "M103.633,45.356c-2.638.4-3.457-5.648-3.457-5.648S88.863,38.054,87.7,28.9a15.539,15.539,0,0,1-7.637,8.679s.161-10.072,8.092-12.21c0,0,9.816-3.829,15.559,3.9s1.691,15.824-.079,16.089",
    transform: "translate(250.973 76.549)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275834",
    "data-name": "Path 275834",
    d: "M81.917,25.34a9.964,9.964,0,0,0,.6,4.176,10.392,10.392,0,0,0,2.212,3.659,9.436,9.436,0,0,0,.777.744l.4.36c.141.107.289.211.434.31.3.2.587.413.893.6.314.165.633.327.951.484.161.079.318.165.48.236l.5.178,1,.36c.686.174,1.377.31,2.063.438-.653-.269-1.319-.463-1.96-.732l-.943-.434-.471-.215c-.149-.083-.294-.178-.442-.265-.294-.178-.587-.356-.885-.525-.281-.19-.546-.409-.823-.608L86.3,33.8l-.372-.351a8.447,8.447,0,0,1-.728-.711,11.894,11.894,0,0,1-2.225-3.4,13.512,13.512,0,0,1-1.054-4",
    transform: "translate(256.699 79.435)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275835",
    "data-name": "Path 275835",
    d: "M86,32.069s3.258-4.3,5.218-3.118-.608,7.488-2.994,8.274a2.392,2.392,0,0,1-3.155-1.41Z",
    transform: "translate(266.685 90.113)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275836",
    "data-name": "Path 275836",
    d: "M89.462,29.229a.032.032,0,0,1,.008.062A6.061,6.061,0,0,0,86.2,32.954a1.324,1.324,0,0,1,1.993-.285c.041.033,0,.1-.05.087a1.475,1.475,0,0,0-1.637.451,7.066,7.066,0,0,0-.827,1.282c-.083.145-.347.054-.285-.112l.017-.041c.037-2.1,1.786-4.982,4.052-5.106",
    transform: "translate(267.662 91.626)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275837",
    "data-name": "Path 275837",
    d: "M84.869,34.262l2.109,6.5,8.406-7.472,2.051,2.721S88.884,48.2,88.872,47.625l-2.233-5.632-4.023,3.539.955-9.5Z",
    transform: "translate(258.986 104.356)",
    fill: "#ffead2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275838",
    "data-name": "Path 275838",
    d: "M83.011,38.764c.211-1.563.376-3.142.662-4.7.008-.054.1-.074.107-.008.211,1.538-.624,7.513-.715,8.956L83.081,43c.17-.153,3.717-3.1,3.746-3.047.5.9,2.15,5,2.253,5.375,1.356-1.939,7.058-9.551,8.625-11.362a.055.055,0,0,1,.091.062c-1.22,2.059-8.6,12.115-8.7,12.078a61.192,61.192,0,0,1-2.332-5.95,42.249,42.249,0,0,1-4.213,3.775,49.092,49.092,0,0,1,.455-5.164",
    transform: "translate(258.798 106.404)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275839",
    "data-name": "Path 275839",
    d: "M9.337,84.067a70.214,70.214,0,0,1,1.625-11.441,25.441,25.441,0,0,1,4.089-9.651,12.254,12.254,0,0,1,8.013-4.995A11.2,11.2,0,0,1,31.5,60.974a40.665,40.665,0,0,1,7.228,8.836,108.872,108.872,0,0,1,6.244,10.924c.062.124-.128.227-.19.1A68.643,68.643,0,0,0,39.195,71.7a57.65,57.65,0,0,0-6.43-7.782c-2.154-2.1-4.891-4.069-8.013-4.168a9.839,9.839,0,0,0-7.84,4.04,24.069,24.069,0,0,0-3.949,9.274,69.065,69.065,0,0,0-1.613,10.891c-.612,7.538-.777,15.121-.947,22.675q-.149,6.419-.194,12.834-.031,3.25-.054,6.5a39.634,39.634,0,0,1-.252,6.268c-.07.422-.757.38-.827-.021a37.014,37.014,0,0,1-.289-5.942q-.043-3.082-.074-6.161c-.033-3.994-.054-7.988-.041-11.983.021-8.013.12-16.064.666-24.061",
    transform: "translate(27.173 181.56)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275840",
    "data-name": "Path 275840",
    d: "M12.657,80.512c.4-2.134,1.116-4.912,2.332-6.562,2.183-2.965,4.54-1.675,2.361,1.608a19.66,19.66,0,0,0-3.064,8.1s3.668,5.239,8.1,7.819a34.858,34.858,0,0,1-.368-8.1c.852-6.471,4.767-6.107,3.8-.968a44.553,44.553,0,0,0-.885,10.4,21.941,21.941,0,0,0,4.73,2.315c-.256-.748-.525-1.65-.823-2.741-1.571-5.805,2.3-7.616,2.423-4.35a45.747,45.747,0,0,0,1.505,8.232c2.121.715,3.883,1.2,4.958,1.579a18.13,18.13,0,0,1,7.261,4.958,22.848,22.848,0,0,0,4.945-6.4c-1.352-1.166-3.49-2.894-6.459-4.991-5.565-3.928-3.63-8.886.786-5.805,3.184,2.229,5.652,6.351,6.769,8.468A34.36,34.36,0,0,0,53.55,82.5c-4.37-4.1-15.179-9.82-11.921-9.82,2.932,0,9.489,4.3,11.9,5.958a30.037,30.037,0,0,0-.368-3.366c-4.118-2.7-17.49-6.9-15.361-8.1,2.34-1.323,11.673,3,14.493,4.362a16.858,16.858,0,0,0-2.473-5.119C44.131,58.8,33.877,56.171,29.4,57.622c-3.167,1.03-2.241,9.059-2.923,8.786-12.719-5.119-18.5-1.5-13.823,14.1m31.177-.881c.9-1.092,5.078,2.117,3.87,3.87s-5.036-2.473-3.87-3.87M22.022,72.78c1.1.7-.525,4.755-2.216,3.527-1.443-1.046,1.112-4.234,2.216-3.527",
    transform: "translate(34.624 179.434)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87492",
    "data-name": "Group 87492",
    transform: "translate(45.669 236.673)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87491",
    "data-name": "Group 87491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87490",
    "data-name": "Group 87490",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275841",
    "data-name": "Path 275841",
    d: "M12.657,80.512c.4-2.134,1.116-4.912,2.332-6.562,2.183-2.965,4.54-1.675,2.361,1.608a19.66,19.66,0,0,0-3.064,8.1s3.668,5.239,8.1,7.819a34.858,34.858,0,0,1-.368-8.1c.852-6.471,4.767-6.107,3.8-.968a44.553,44.553,0,0,0-.885,10.4,21.941,21.941,0,0,0,4.73,2.315c-.256-.748-.525-1.65-.823-2.741-1.571-5.805,2.3-7.616,2.423-4.35a45.747,45.747,0,0,0,1.505,8.232c2.121.715,3.883,1.2,4.958,1.579a18.13,18.13,0,0,1,7.261,4.958,22.848,22.848,0,0,0,4.945-6.4c-1.352-1.166-3.49-2.894-6.459-4.991-5.565-3.928-3.63-8.886.786-5.805,3.184,2.229,5.652,6.351,6.769,8.468A34.36,34.36,0,0,0,53.55,82.5c-4.37-4.1-15.179-9.82-11.921-9.82,2.932,0,9.489,4.3,11.9,5.958a30.037,30.037,0,0,0-.368-3.366c-4.118-2.7-17.49-6.9-15.361-8.1,2.34-1.323,11.673,3,14.493,4.362a16.858,16.858,0,0,0-2.473-5.119C44.131,58.8,33.877,56.171,29.4,57.622c-3.167,1.03-2.241,9.059-2.923,8.786-12.719-5.119-18.5-1.5-13.823,14.1m31.177-.881c.9-1.092,5.078,2.117,3.87,3.87s-5.036-2.473-3.87-3.87M22.022,72.78c1.1.7-.525,4.755-2.216,3.527-1.443-1.046,1.112-4.234,2.216-3.527",
    transform: "translate(-11.044 -57.239)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275842",
    "data-name": "Path 275842",
    d: "M16.482,66.778c.575-1.133,1.174-2.262,1.828-3.353a19.642,19.642,0,0,1,2.1-3.047c-.182-.223-.356-.451-.542-.67-.074-.091.054-.215.132-.128.215.244.418.492.624.74a.194.194,0,0,1,.087.1c.786.943,1.526,1.914,2.233,2.9a33.982,33.982,0,0,1,3.7,1.071c1.245.418,2.481.852,3.692,1.36.128.054.066.265-.058.207-1.2-.529-2.423-1.046-3.668-1.464-1.178-.4-2.373-.707-3.568-1.042.389.546.769,1.1,1.133,1.662a43.464,43.464,0,0,1,6.533,2.663c2.208,1.05,4.333,2.266,6.446,3.49a.107.107,0,0,1-.112.182,71.768,71.768,0,0,0-6.413-3.316c-2.047-.959-4.164-1.745-6.227-2.659,5.193,8.108,8.311,17.461,12.479,26.12.058.124-.141.232-.194.1-1.269-3.035-2.733-6-4.118-8.985-1.245-2.679-2.456-5.375-3.7-8.059-.364-.786-.74-1.567-1.121-2.349.227,4.329.136,8.733.844,13.012a.107.107,0,1,1-.211.025c-.3-4.627-1.116-9.183-1.083-13.835,0-.025.021-.037.025-.058-.881-1.77-1.819-3.515-2.832-5.214-1.72,4.052-3.531,8.166-4.333,12.516-.025.132-.244.074-.207-.062,1.17-4.362,2.253-8.729,4.354-12.76a49.259,49.259,0,0,0-3.655-5.272c-.579,1.079-1.319,2.1-1.976,3.126-.641,1-1.269,2.014-1.861,3.052a44.491,44.491,0,0,0-3.25,6.864c-.045.132-.26.066-.207-.062.992-2.3,2-4.623,3.13-6.864",
    transform: "translate(41.828 186.676)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275843",
    "data-name": "Path 275843",
    d: "M4.224,69.535c3.333-3.341,7.207-7.732,12.359-7.72,4.97.008,8.629,4.011,10.73,8.137,2.2,4.321,2.989,9.212,3.61,13.967a169.188,169.188,0,0,1,1.319,17.172c.091,3.188.079,6.376,0,9.564a63.343,63.343,0,0,1-.732,9.655c-.091.513-.918.533-.951-.021-.149-2.688-.041-5.384-.025-8.071q.019-3.963-.124-7.935c-.2-5.35-.587-10.688-1.216-16.006-.546-4.643-.984-9.419-2.373-13.905-1.253-4.044-3.6-8.671-7.7-10.449-5.6-2.423-11.065,2.005-14.728,5.747-.1.1-.265-.037-.165-.136",
    transform: "translate(13.147 193.777)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275844",
    "data-name": "Path 275844",
    d: "M.114,82.85v.008c.025.682.066,1.36.112,2.018a12.05,12.05,0,0,1,5.462-2.262c4.73-.5,4.428,3.093,1.269,3.246a18.023,18.023,0,0,0-6.492,1.3c.773,6.248,2.489,11.267,2.75,11.338a92.056,92.056,0,0,0,12.5-1.58c-1.174-2.506-3.854-5.838-2.489-6.107,1.4-.277,2.861,2.7,3.614,5.88a59.856,59.856,0,0,0,9.092-2.506c-2.08-1.8-5.3-4.04-4.069-4.995s3.783,2.2,5.313,4.495A18.445,18.445,0,0,0,31.1,91.492c-2.8-4.118-9.638-4.958-8.745-7.935.91-3.035,7.286,1.154,10.155,6.665,3.37-3.494,4.358-8.443,4-12.669-2.936-.343-8.584.277-8.175-1.832.385-2.005,4.49-1.708,7.831-.476A11.708,11.708,0,0,0,34.21,70.6c-3.1-3.974-12.537,1.079-12.537,1.079s1.009-9.489-2.593-11.131C17,59.6,13.341,59.613,9.665,61.775c2.063.17,4.552.823,5.553,2.254,1.282,1.823-.74,2.816-2.022,1.976-.906-.6-2.6-2.477-5.644-2.725a18.781,18.781,0,0,0-3.407,3.775,18.586,18.586,0,0,0-1,1.571,12.946,12.946,0,0,1,11.052.2c4.1,2.034,1.811,6.285-1.712,4.631C9,71.827,5.609,70.181,1.875,71.116A26.5,26.5,0,0,0,.081,81.7,18.546,18.546,0,0,1,6.147,78.79c4.069-1.067,5.3,1.364.827,1.819A17.934,17.934,0,0,0,.114,82.85m4.954-6.533c-.281-1.319,2.6-1.7,3.085-.629.4.914-2.812,1.948-3.085.629m24.7,7.3c.269-.719,2.2.1,2.026,1-.24,1.2-2.291-.277-2.026-1M16.128,88.246c1.406-.562,3.606,2.936,2.072,3.738s-3.221-3.275-2.072-3.738",
    transform: "translate(0.25 187.929)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87495",
    "data-name": "Group 87495",
    transform: "translate(0.331 247.879)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87494",
    "data-name": "Group 87494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87493",
    "data-name": "Group 87493",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275845",
    "data-name": "Path 275845",
    d: "M.114,82.85v.008c.025.682.066,1.36.112,2.018a12.05,12.05,0,0,1,5.462-2.262c4.73-.5,4.428,3.093,1.269,3.246a18.023,18.023,0,0,0-6.492,1.3c.773,6.248,2.489,11.267,2.75,11.338a92.056,92.056,0,0,0,12.5-1.58c-1.174-2.506-3.854-5.838-2.489-6.107,1.4-.277,2.861,2.7,3.614,5.88a59.856,59.856,0,0,0,9.092-2.506c-2.08-1.8-5.3-4.04-4.069-4.995s3.783,2.2,5.313,4.495A18.445,18.445,0,0,0,31.1,91.492c-2.8-4.118-9.638-4.958-8.745-7.935.91-3.035,7.286,1.154,10.155,6.665,3.37-3.494,4.358-8.443,4-12.669-2.936-.343-8.584.277-8.175-1.832.385-2.005,4.49-1.708,7.831-.476A11.708,11.708,0,0,0,34.21,70.6c-3.1-3.974-12.537,1.079-12.537,1.079s1.009-9.489-2.593-11.131C17,59.6,13.341,59.613,9.665,61.775c2.063.17,4.552.823,5.553,2.254,1.282,1.823-.74,2.816-2.022,1.976-.906-.6-2.6-2.477-5.644-2.725a18.781,18.781,0,0,0-3.407,3.775,18.586,18.586,0,0,0-1,1.571,12.946,12.946,0,0,1,11.052.2c4.1,2.034,1.811,6.285-1.712,4.631C9,71.827,5.609,70.181,1.875,71.116A26.5,26.5,0,0,0,.081,81.7,18.546,18.546,0,0,1,6.147,78.79c4.069-1.067,5.3,1.364.827,1.819A17.934,17.934,0,0,0,.114,82.85m4.954-6.533c-.281-1.319,2.6-1.7,3.085-.629.4.914-2.812,1.948-3.085.629m24.7,7.3c.269-.719,2.2.1,2.026,1-.24,1.2-2.291-.277-2.026-1M16.128,88.246c1.406-.562,3.606,2.936,2.072,3.738s-3.221-3.275-2.072-3.738",
    transform: "translate(-0.081 -59.95)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275846",
    "data-name": "Path 275846",
    d: "M.982,88.627C3.1,85.08,5.2,81.515,7.428,78.034q1.557-2.431,3.25-4.772c-.17-.033-.339-.083-.5-.12q-.422-.087-.844-.161c-.653-.112-1.311-.207-1.968-.273-.616-.062-1.24-.1-1.861-.1a9.174,9.174,0,0,0-1.993.1c-.079.017-.091-.108-.017-.108.666.029,1.344-.058,2.005-.066.645-.012,1.29,0,1.935.045.6.033,1.2.1,1.8.186.331.05.662.108.988.174a5.936,5.936,0,0,1,.6.124q1.718-2.369,3.572-4.643a42.471,42.471,0,0,0-11.611-3.7c-.07-.012-.045-.116.025-.108a39.383,39.383,0,0,1,11.78,3.577c.678-.835,1.36-1.662,2.047-2.489.765-.922,1.588-1.823,2.282-2.8a.055.055,0,1,1,.087.066,39.246,39.246,0,0,0-2.692,3.3h.017a40.956,40.956,0,0,1,4.317,3.469Q22.768,71.6,24.773,73.6c.05.045-.025.124-.074.074-1.323-1.311-2.692-2.568-4.127-3.759s-2.94-2.287-4.383-3.465l-.012-.021c-.327.434-.657.872-.988,1.3-.165.219-.331.434-.5.653l-.037.045q-.825,1.079-1.646,2.163a17.309,17.309,0,0,1,1.637,2.956c.476,1,.889,2.034,1.269,3.076a44.962,44.962,0,0,1,1.77,6.645c.012.066-.091.1-.1.029a38.869,38.869,0,0,0-1.931-6.512c-.413-1.087-.881-2.142-1.364-3.2-.442-.959-.976-1.881-1.389-2.853q-.713.949-1.414,1.906c-.132.186-.265.376-.4.566.021.041.008.1-.045.1h-.025c-1.455,2.034-2.845,4.118-4.193,6.223a1.973,1.973,0,0,1,.186.463c.087.256.165.513.244.773a15.9,15.9,0,0,1,.368,1.58c.091.5.161,1,.211,1.509a14.7,14.7,0,0,0,.128,1.716c.021.087-.12.091-.1,0a5.525,5.525,0,0,0-.12-1.6c-.074-.546-.178-1.092-.3-1.629-.116-.488-.248-.972-.393-1.451-.07-.24-.149-.48-.232-.715-.045-.128-.1-.261-.149-.393-.628.988-1.257,1.985-1.873,2.985q-1.83,2.971-3.647,5.954c-.062.1-.223.017-.161-.087",
    transform: "translate(3.033 197.078)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275847",
    "data-name": "Path 275847",
    d: "M8.883,101.912c.054-2.009.372-4.036.591-6.033s.442-4.015.657-6.024a91.462,91.462,0,0,1,1.555-11.623,16.912,16.912,0,0,1,4.73-8.691,7.716,7.716,0,0,1,4.635-2.212,7.99,7.99,0,0,1,4.925,1.517,17.166,17.166,0,0,1,4.139,4.362,42.4,42.4,0,0,1,3.229,5.243c.037.07-.07.112-.108.05a26.863,26.863,0,0,0-6.988-7.827,8.23,8.23,0,0,0-4.4-1.836,5.965,5.965,0,0,0-4.267,1.7,16.031,16.031,0,0,0-4.511,7.976,81.721,81.721,0,0,0-1.745,10.738c-.285,2.125-.554,4.255-.835,6.38s-.455,4.288-.906,6.372a.353.353,0,0,1-.7-.1",
    transform: "translate(27.846 211.029)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275848",
    "data-name": "Path 275848",
    d: "M13.217,87.04A11.139,11.139,0,0,0,15.4,89.272c-.331-1.96-.732-5.446.26-7.3,1.534-2.882,3.357-1.443,2.44,1.063a20.408,20.408,0,0,0-1.48,7.1A30.83,30.83,0,0,0,23.3,93.283a11.176,11.176,0,0,1-.219-3.436c.306-3.08,2.663-3.023,2.051.182a19.539,19.539,0,0,0-.323,3.763A69.518,69.518,0,0,0,35.219,96.14a30.377,30.377,0,0,0,4.3-7.666c-2.506-.628-7.583-.773-7.476-2.564.145-2.411,5.061-.554,7.939,1.195a19.247,19.247,0,0,0,.868-6.488,32.153,32.153,0,0,0-6.913-1.145c-5.164-.447-4.908-3.374-1.17-3.308,2.762.05,6.252,1.741,7.91,2.621-1.079-7.025-6.434-11.524-10.73-11.7-7.224-.289-4.623,8.7-4.623,8.7s-4.891-3.444-9.51-3.353-7.538,7.74-2.6,14.608M32.5,74.052c-.157-1.013,3.064-1.257,3.233.041.19,1.455-3.068.984-3.233-.041m5.185,10.54c-.066-.662,1.327-.777,1.642.058.211.542-1.584.6-1.642-.058m-17.337.616c1.087.153,1.708,4.044-.165,3.969-1.431-.062-.757-4.1.165-3.969",
    transform: "translate(33.398 210.289)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87498",
    "data-name": "Group 87498",
    transform: "translate(44.054 277.373)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87497",
    "data-name": "Group 87497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87496",
    "data-name": "Group 87496",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275849",
    "data-name": "Path 275849",
    d: "M13.217,87.04A11.139,11.139,0,0,0,15.4,89.272c-.331-1.96-.732-5.446.26-7.3,1.534-2.882,3.357-1.443,2.44,1.063a20.408,20.408,0,0,0-1.48,7.1A30.83,30.83,0,0,0,23.3,93.283a11.176,11.176,0,0,1-.219-3.436c.306-3.08,2.663-3.023,2.051.182a19.539,19.539,0,0,0-.323,3.763A69.518,69.518,0,0,0,35.219,96.14a30.377,30.377,0,0,0,4.3-7.666c-2.506-.628-7.583-.773-7.476-2.564.145-2.411,5.061-.554,7.939,1.195a19.247,19.247,0,0,0,.868-6.488,32.153,32.153,0,0,0-6.913-1.145c-5.164-.447-4.908-3.374-1.17-3.308,2.762.05,6.252,1.741,7.91,2.621-1.079-7.025-6.434-11.524-10.73-11.7-7.224-.289-4.623,8.7-4.623,8.7s-4.891-3.444-9.51-3.353-7.538,7.74-2.6,14.608M32.5,74.052c-.157-1.013,3.064-1.257,3.233.041.19,1.455-3.068.984-3.233-.041m5.185,10.54c-.066-.662,1.327-.777,1.642.058.211.542-1.584.6-1.642-.058m-17.337.616c1.087.153,1.708,4.044-.165,3.969-1.431-.062-.757-4.1.165-3.969",
    transform: "translate(-10.656 -67.084)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_275850",
    "data-name": "Path 275850",
    d: "M13.368,73.627c.178-.484.339-.976.492-1.472-.141.5-.265,1-.36,1.509a.069.069,0,1,1-.132-.037",
    transform: "translate(41.889 226.191)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275851",
    "data-name": "Path 275851",
    d: "M14.819,76.407c.339-1,.719-1.985,1.1-2.961.211-.525.422-1.042.653-1.559a6.352,6.352,0,0,1,.641-1.3,10.188,10.188,0,0,1-.583-1.261.039.039,0,0,1,.066-.037,15.231,15.231,0,0,1,1.406,2.183c.2.339.393.686.591,1.03a10.843,10.843,0,0,1,1.212.186c.434.083.864.17,1.294.265s.86.2,1.29.3.848.24,1.278.306c.1.017.058.174-.037.136a7.975,7.975,0,0,0-1.348-.351c-.418-.091-.831-.165-1.253-.223s-.839-.112-1.261-.153c-.314-.033-.637-.05-.955-.079.174.3.351.6.521.906l.074.149a4.026,4.026,0,0,1,1.038.12c.372.066.744.141,1.116.219.753.17,1.5.347,2.245.554,1.563.434,3.105.934,4.648,1.439.087.029.033.157-.054.128a45.646,45.646,0,0,0-4.668-1.294c-.74-.165-1.476-.335-2.216-.492-.372-.074-.744-.157-1.116-.236a7.589,7.589,0,0,1-.86-.19c.794,1.468,1.542,2.961,2.229,4.482,1.5,3.312,2.758,6.727,4.044,10.126.033.083-.1.141-.128.054a92.858,92.858,0,0,0-4.3-9.9c-.285-.587-.583-1.17-.877-1.757-.025.12-.054.236-.074.36-.074.4-.145.8-.215,1.2-.132.806-.273,1.613-.393,2.419a28.565,28.565,0,0,0-.583,5.02c0,.1-.153.1-.136,0,.128-.8.128-1.637.178-2.444.054-.848.116-1.691.215-2.531.1-.81.2-1.625.331-2.427.066-.405.136-.806.211-1.207a2.367,2.367,0,0,1,.227-.872c-.422-.852-.839-1.7-1.269-2.547q-.6-1.191-1.22-2.373c-.174-.331-.364-.67-.55-1.009A9.283,9.283,0,0,1,16.849,72c-.182.455-.368.91-.558,1.369-.413,1-.8,2.022-1.183,3.043-.546,1.443-1.149,2.923-1.6,4.424.442-1.472.815-2.977,1.311-4.432",
    transform: "translate(42.345 217.159)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275852",
    "data-name": "Path 275852",
    d: "M13.483,72.419c.033-.116.07-.232.1-.347-.033.116-.066.232-.1.347",
    transform: "translate(42.267 225.931)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275853",
    "data-name": "Path 275853",
    d: "M5.963,74.739,6.472,85.49l1.307,27.7H36.362l1.307-27.7.509-10.751Z",
    transform: "translate(18.694 234.292)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275854",
    "data-name": "Path 275854",
    d: "M5.963,74.739,6.472,85.49h31.2l.509-10.751Z",
    transform: "translate(18.694 234.292)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25364",
    "data-name": "Rectangle 25364",
    width: 36.279,
    height: 8.691,
    transform: "translate(22.626 304.686)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25365",
    "data-name": "Rectangle 25365",
    width: 5.02,
    height: 4.548,
    transform: "translate(47.724 347.486)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25366",
    "data-name": "Rectangle 25366",
    width: 5.02,
    height: 2.274,
    transform: "translate(47.72 347.486)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25367",
    "data-name": "Rectangle 25367",
    width: 5.016,
    height: 4.548,
    transform: "translate(28.787 347.486)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25368",
    "data-name": "Rectangle 25368",
    width: 5.016,
    height: 2.274,
    transform: "translate(28.787 347.486)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275855",
    "data-name": "Path 275855",
    d: "M105.225,41.19a11.3,11.3,0,0,0,1.935-6.252c0-7.918-8.7-14.34-19.417-14.34S68.334,27.02,68.334,34.939s8.687,14.34,19.409,14.34a23.325,23.325,0,0,0,13.393-3.965l6.69,1.7Z",
    transform: "translate(214.214 64.572)",
    fill: "#fffdfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275856",
    "data-name": "Path 275856",
    d: "M105.516,41.439c5.288-7.8-1.65-16.949-9.609-19.045C88.1,19.9,78.652,21.216,72.727,27,65.9,33.372,69.6,43.445,77.54,46.839c7.422,3.539,16.841,3.209,23.763-1.451l.087-.058.091.025,6.661,1.807-.12.141Zm0,0,2.692,5.78.087.19-.2-.05-6.715-1.6c-6.1,4.7-16.692,5.342-24.16,1.728-8.464-3.544-12.508-14.335-5.1-21.1,6.33-6.008,15.989-7.178,23.97-4.548,8.146,2.15,15.088,11.855,9.427,19.595",
    transform: "translate(213.923 64.324)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275857",
    "data-name": "Path 275857",
    d: "M74.393,25.594A2.014,2.014,0,1,1,72.38,23.58a2.013,2.013,0,0,1,2.014,2.014",
    transform: "translate(220.584 73.917)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275858",
    "data-name": "Path 275858",
    d: "M76.569,25.594a2.014,2.014,0,1,1-2.014-2.014,2.013,2.013,0,0,1,2.014,2.014",
    transform: "translate(227.406 73.917)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275859",
    "data-name": "Path 275859",
    d: "M78.744,25.594a2.014,2.014,0,1,1-2.014-2.014,2.013,2.013,0,0,1,2.014,2.014",
    transform: "translate(234.224 73.917)",
    fill: "#1a2e35"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11To1SessionDashboard);
export default __webpack_public_path__ + "static/media/1_1to1_Session__Dashboard.ce2f005d44f4132bf7f934b94734985b.svg";
export { ForwardRef as ReactComponent };